//
// This file is AUTO-GENERATED by protoc-gen-ts.
// Do not modify it manually.
///
import api from '../../api'
import * as googleTypes from '../../googleTypes'
import { Budget as arangodb_cloud_common_v1_Budget } from '../../common/v1/common'
import { ListOptions as arangodb_cloud_common_v1_ListOptions } from '../../common/v1/common'
import { DataVolumeInfo as arangodb_cloud_data_v1_DataVolumeInfo } from './data'
import { Deployment as arangodb_cloud_data_v1_Deployment } from './data'
import { DeploymentSize as arangodb_cloud_data_v1_DeploymentSize } from './data'
import { DiskPerformance as arangodb_cloud_data_v1_DiskPerformance } from './data'
import { NotificationSeverity as arangodb_cloud_data_v1_NotificationSeverity } from './data'
import { RotateDeploymentServerRequest as arangodb_cloud_data_v1_RotateDeploymentServerRequest } from './data'
import { JSONPatch as arangodb_cloud_internal_common_v1_JSONPatch } from '../../common/v1/icommon'
import { KeyValuePair as arangodb_cloud_internal_common_v1_KeyValuePair } from '../../common/v1/icommon'
import { Money as arangodb_cloud_internal_common_v1_Money } from '../../common/v1/icommon'
import { EmailAddressList as arangodb_cloud_internal_email_v1_EmailAddressList } from '../../email/v1/iemail'
import { SchedulingPolicy as arangodb_cloud_internal_scheduling_v1_SchedulingPolicy } from '../../scheduling/v1/ischeduling'
import { DeploymentReplication as arangodb_cloud_replication_v1_DeploymentReplication } from '../../replication/v1/replication'

// File: data/v1/idata.proto
// Package: arangodb.cloud.internal.data.v1

// AddonResourceValues holds absolute k8s request quantities for one addon role.
// These are carve REQUEST bases (within budget), not limits.
// Values are Kubernetes quantity strings, e.g. "256Mi", "250m".
export interface AddonResourceValues {
  // Memory request for this role.
  // string
  memory?: string;
  
  // CPU request for this role.
  // string
  cpu?: string;
}

// AddonResources holds absolute request defaults/overrides for optional components.
export interface AddonResources {
  // Gateway pod requests. Unused when platform/gateway is off.
  // AddonResourceValues
  gateway?: AddonResourceValues;
  
  // Dedicated load balancer (Envoy) pod requests. Unused with shared LB.
  // AddonResourceValues
  loadbalancer?: AddonResourceValues;
}

// CPUFactors defines independent multipliers applied to calculated CPU requests per role.
// On scheduling v3 these multiply the post-carve base (default 1.0 after upgrade).
// Allowed range is typically 0.5–2.0 (enforced by datad).
export interface CPUFactors {
  // CPU factor for coordinator. Default is 1.0.
  // number
  coordinator_factor?: number;
  
  // CPU factor for DB server (also used for single-server). Default is 1.0.
  // number
  dbserver_factor?: number;
  
  // CPU factor for gateway. Default is 1.0. Unused when platform/gateway is off.
  // number
  gateway_factor?: number;
  
  // CPU factor for dedicated load balancer. Default is 1.0. Unused with shared LB.
  // number
  loadbalancer_factor?: number;
}

// CPURatio of percents for coordinator and dbserver.
// The sum of all values should be 100.
// All values must be > 0 and < 100.
export interface CPURatio {
  // A CPU percent for coordinator.
  // number
  coordinator_percent?: number;
  
  // A CPU percent for DB server.
  // number
  dbserver_percent?: number;
}

// CPURequestToLimitSpec holds the ratio from CPU request to CPU limit.
// E.g. A value of 2 means that a request of 1vCPU yields a limit of 2vCPU.
// All ratios must be >= 1.
export interface CPURequestToLimitSpec {
  // CPU request to limit ratio for agents
  // string
  agents?: string;
  
  // CPU request to limit ratio for coordinators
  // string
  coordinators?: string;
  
  // CPU request to limit ratio for dbservers
  // string
  dbservers?: string;
  
  // CPU request to limit ratio for gateways
  // string
  gateways?: string;
  
  // CPU request to limit ratio for dedicated load balancers (optional)
  // string
  loadbalancers?: string;
}

// Nested response inside GetProvisionInfoResponse containing all info for Cilium Provisioning
export interface CiliumProvisionInfo {
  // Flag if we should deploy Cilium or not (if set to false all other information is this block is not relevant).
  // Note: Setting this bool to false when already deployed will not remove Cilium
  // boolean
  deploy_cilium?: boolean;
  
  // Flag if the standard (build-in) policies should be applied
  // Note: Setting this flag to false when already deployed will not remove them
  // boolean
  deploy_standard_policies?: boolean;
  
  // Yaml content to be applied to API server containing additional cilium network policies
  // string
  deploy_additional_policies_yaml?: string;
  
  // Name-Namespace pairs for the standard or additional cilium network policies we want to remove
  // Note: If the policies in this collection are a standard one and deploy_standard_policies=true or contained in the deploy_additional_policies_yaml,
  // the policy will alter between there and not there.
  // ResourceIdentifier
  policies_to_remove?: ResourceIdentifier[];
  
  // Name-Namespace pairs for the standard or additional cilium network policies we have to wait on until we continue the deployment
  // An empty list means: do not wait at-all
  // ResourceIdentifier
  policies_to_wait_on?: ResourceIdentifier[];
  
  // Cilium version to be deployed on the given data cluster.
  // string
  cilium_version?: string;
}

// CoreDumpFilter hold all individual flags for the core dump filter.
export interface CoreDumpFilter {
  // [bit 0] Dump anonymous private mappings.
  // boolean
  dump_anonymous_private_mappings?: boolean;
  
  // [bit 1] Dump anonymous shared mappings.
  // boolean
  dump_anonymous_shared_mappings?: boolean;
  
  // [bit 2] Dump file-backed private mappings.
  // boolean
  dump_file_backed_private_mappings?: boolean;
  
  // [bit 3] Dump file-backed shared mappings.
  // boolean
  dump_file_backed_shared_mappings?: boolean;
  
  // [bit 4] Dump ELF headers (since Linux 2.6.24).
  // boolean
  dump_ELF_headers?: boolean;
  
  // [bit 5] Dump private huge pages (since Linux 2.6.28).
  // boolean
  dump_private_huge_pages?: boolean;
  
  // [bit 6] Dump shared huge pages (since Linux 2.6.28).
  // boolean
  dump_shared_huge_pages?: boolean;
  
  // [bit 7] Dump private DAX pages (since Linux 4.4).
  // boolean
  dump_private_DAX_pages?: boolean;
  
  // [bit 8] Dump shared DAX pages (since Linux 4.4).
  // boolean
  dump_shared_DAX_pages?: boolean;
}

// Specification & status of a data-cluster; a kubernetes cluster that is used
// to run Deployments.
export interface DataCluster {
  // System identifier of the data cluster.
  // This is a read-only value.
  // string
  id?: string;
  
  // Identifier of the provider in which this data cluster is supposed to be running.
  // See platform.Provider.ID
  // This value cannot be changed after creation.
  // string
  provider_id?: string;
  
  // Identifier of the region in which this data cluster is supposed to be running
  // See platform.Region.ID
  // This value cannot be changed after creation.
  // string
  region_id?: string;
  
  // Set when this data cluster is deleted.
  // This is a read-only value.
  // boolean
  is_deleted?: boolean;
  
  // The creation timestamp of the data cluster
  // This is a read-only value.
  // googleTypes.Timestamp
  created_at?: googleTypes.Timestamp;
  
  // The deletion timestamp of the data cluster
  // This is a read-only value.
  // googleTypes.Timestamp
  deleted_at?: googleTypes.Timestamp;
  
  // The timestamp of the last assignment or unassignment
  // of this data cluster.
  // This is a read-only value.
  // googleTypes.Timestamp
  last_assignment_changed_at?: googleTypes.Timestamp;
  
  // If set, new deployments cannot be assigned to this datacluster.
  // boolean
  is_unassignable?: boolean;
  
  // List of labels, containing free text
  // string
  labels?: string[];
  
  // List of annotations, containing free text key-value pairs
  // Please use UpdateDataClusterAnnotations to update, the normal UpdateDataCluster will ignore them
  // arangodb.cloud.internal.common.v1.KeyValuePair
  annotations?: arangodb_cloud_internal_common_v1_KeyValuePair[];
  
  // If set the datacluster allows reboot node operations
  // These are performed by node-reboot-required pod under management from the data-cluster-provisioner
  // See the DataCluster.Status.is_reboot_nodes_running if the process is actually running
  // boolean
  reboot_nodes_allowed?: boolean;
  
  // If set the datacluster allows (k8s) upgrade nodepools operations
  // These are performed by data-cluster-operator-<provider>
  // See the DataCluster.Status.is_nodepool_upgrading if the process is actually running
  // boolean
  upgrade_nodepools_allowed?: boolean;
  
  // If set this datacluster is in maintenance mode.
  // Resulting in that the data-cluster-operator-<provider> and data-cluster-provisioner aren't updating any resources for this
  // datacluster in the reconciliation loop anymore.
  // boolean
  in_maintenance_mode?: boolean;
  
  // Readonly list of finalizers that are currently put on this datacluster
  // string
  finalizers?: string[];
  
  // If set this datacluster will have Cilium Hubble enabled, otherwise it will be disabled.
  // boolean
  enable_cilium_hubble?: boolean;
  
  // If set, this datacluster will have the Prometheus memory size limit set to the custom value, otherwise the default from the config map will be used.
  // string
  prometheus_memory_size_limit?: string;
  
  // If set, the volume info attributes (like type, iops and throughput) for NATS Streaming, otherwise the default from the system will be used.
  // All fields inside this message are read-only, use UpdateDataClusterVolumeInfos to update.
  // VolumeInfo
  nats_streaming_volume_info?: VolumeInfo;
  
  // If set, the quantity to use for the persistent volume for NATS Streaming, otherwise the default from the system will be used.
  // (follows kubernetes resource request format)
  // This field is read-only, use UpdateDataClusterDiskSizes to update.
  // string
  nats_streaming_disk_size?: string;
  
  // If set, the volume info attributes (like type, iops and throughput) for NATS JetStream, otherwise the default from the system will be used.
  // All fields inside this message are read-only, use UpdateDataClusterVolumeInfos to update.
  // VolumeInfo
  nats_jetstream_volume_info?: VolumeInfo;
  
  // If set, the quantity to use for the persistent volume for NATS JetStream, otherwise the default from the system will be used.
  // (follows kubernetes resource request format)
  // This field is read-only, use UpdateDataClusterDiskSizes to update.
  // string
  nats_jetstream_disk_size?: string;
  
  // If set, the volume info attributes (like type, iops and throughput) for Loki, otherwise the default from the system will be used.
  // All fields inside this message are read-only, use UpdateDataClusterVolumeInfos to update.
  // VolumeInfo
  loki_volume_info?: VolumeInfo;
  
  // If set, the quantity to use for the persistent volume for Loki, otherwise the default from the system will be used.
  // (follows kubernetes resource request format)
  // This field is read-only, use UpdateDataClusterDiskSizes to update.
  // string
  loki_disk_size?: string;
  
  // If set, the volume info attributes (like type, iops and throughput) for Prometheus, otherwise the default from the system will be used.
  // All fields inside this message are read-only, use UpdateDataClusterVolumeInfos to update.
  // VolumeInfo
  prometheus_volume_info?: VolumeInfo;
  
  // If set, the quantity to use for the persistent volume for Prometheus, otherwise the default from the system will be used.
  // (follows kubernetes resource request format)
  // This field is read-only, use UpdateDataClusterDiskSizes to update.
  // string
  prometheus_disk_size?: string;
  
  // Latest provision info which have been configured (in the controlplane)
  // This is a read-only value.
  // DataClusterProvisionInfo
  latest_provision_info?: DataClusterProvisionInfo;
  
  // Target provision info that this datacluster is configured to use
  // DataClusterProvisionInfo
  target_provision_info?: DataClusterProvisionInfo;
  
  // Previous provision info that this datacluster was configured to use (fill-out when a new target_provision_info is set)
  // This can be seen as last-known-good and can be used to revert to
  // This is a read-only value.
  // DataClusterProvisionInfo
  previous_target_provision_info?: DataClusterProvisionInfo;
  
  // The timestamp of the last target_provision_info change for this datacluster
  // This is a read-only value.
  // googleTypes.Timestamp
  last_target_provision_info_changed_at?: googleTypes.Timestamp;
  
  // URL of this resource
  // This is a read-only value.
  // string
  url?: string;
  
  // Organization identifiers for which this data cluster is private to
  // This field is an empty array of string by default
  // If set, the values identifies the organizations for which this data cluster is priavte to.
  // string
  private_to_organizations?: string[];
  
  // How this data cluster is dedicated, which decides how its cost is
  // attributed. Says at what granularity the cluster is dedicated;
  // private_to_organizations says to whom.
  // The value records the mode the cluster was created in and does not follow
  // later changes of the organization flags: the cluster does not change shape
  // when a flag is flipped, so neither may its charge.
  // Empty (NONE) on a cluster with a non-empty private_to_organizations means
  // the cluster predates this field and its mode has not been recorded yet.
  // This is a read-only value, set at creation.
  // DataClusterDedicationMode
  dedication_mode?: DataClusterDedicationMode;
  
  // If set, this datacluster has machine types that have local SSD support (for example, AWS i4i.4xlarge machines)
  // This is a read-only value.
  // boolean
  uses_local_ssd?: boolean;
  
  // Set if core dumps are enabled for this data cluster.
  // This field is read-only, use UpdateDataClusterCoreDump to update.
  // boolean
  is_core_dump_enabled?: boolean;
  
  // Set if OTel export to Dash0 is enabled for this data cluster.
  // This field is read-only, use UpdateDataClusterOtelEnabled to update.
  // boolean
  is_otel_enabled?: boolean;
  
  // Define number of concurrent nodes update operations allowed
  // This field is read-only, use UpdateDataClusterNodeUpdateConcurrencyLevel to update.
  // number
  node_update_concurrency_level?: number;
  
  // DataCluster_Status
  status?: DataCluster_Status;
}

// Status of a DataCluster
export interface DataCluster_Status {
  // Current phase of the cluster.
  // The semantics of this field is provider specific.
  // string
  phase?: string;
  
  // Identifier of the kubernetes cluster, given by the cloud provider.
  // string
  provider_cluster_id?: string;
  
  // Set when the data cluster is not available to assign deployments to.
  // This can happen when the data cluster has reached its maximum capacity.
  // boolean
  is_unavailable?: boolean;
  
  // Set when the data cluster is in a running state
  // boolean
  is_running?: boolean;
  
  // Set when the data cluster master is upgrading to a new software version (of Kubernetes or controlplane components)
  // boolean
  is_upgrading?: boolean;
  
  // Set when the data cluster is in an error state that requires human intervention
  // boolean
  is_failing?: boolean;
  
  // Human readable message describing the state of the datacluster.
  // string
  message?: string;
  
  // Endpoint of the API server of the cluster
  // string
  endpoint?: string;
  
  // The timestamp of the last ping from this data cluster (combined last from data-cluster-provisioner and data-manager)
  // googleTypes.Timestamp
  last_ping_at?: googleTypes.Timestamp;
  
  // Set when at least one of the data cluster nodepools is upgrading to a new software version (of Kubernetes)
  // This process can be only running if DataCluster.upgrade_nodepools_allowed is set
  // boolean
  is_nodepool_upgrading?: boolean;
  
  // Version of data-cluster-provisioner running on this datacluster
  // string
  data_cluster_provision_version?: string;
  
  // Version of data-manager running on this datacluster
  // string
  data_manager_version?: string;
  
  // The timestamp of the last ping from this data cluster from the data-cluster-provisioner
  // googleTypes.Timestamp
  data_cluster_provision_last_ping_at?: googleTypes.Timestamp;
  
  // The timestamp of the last ping from this data cluster from the data-manager
  // googleTypes.Timestamp
  data_manager_last_ping_at?: googleTypes.Timestamp;
  
  // Version of route-manager running on this datacluster
  // string
  route_manager_version?: string;
  
  // Version of health-manager running on this datacluster
  // string
  health_manager_version?: string;
  
  // Version of bucket-manager running on this datacluster
  // string
  bucket_manager_version?: string;
  
  // Version of metrics-server running on this datacluster
  // string
  metrics_server_version?: string;
  
  // Nodes of the cluster
  // NodeList
  nodes?: NodeList;
  
  // Content hash of status.nodes (Equals-compatible; excludes usage).
  // Used by data-cluster-provisioner to omit unchanged NodeList on ping.
  // string
  nodes_hash?: string;
  
  // Pod statistics on the cluster (globally)
  // PodStatistics
  pod_statistics?: PodStatistics;
  
  // Pod statistics on the cluster (per namespace)
  // PodStatisticsInNamespace
  pod_statistics_per_namespace?: PodStatisticsInNamespace[];
  
  // Metrics namespace related info on the cluster
  // MetricsInfo
  metrics_info?: MetricsInfo;
  
  // Set if the reboot nodes process is running
  // This process can be only running if DataCluster.reboot_nodes_allowed is set
  // boolean
  is_reboot_nodes_running?: boolean;
  
  // The provision_info_hash as used on this datacluster
  // string
  provision_info_hash?: string;
  
  // The timestamp of the last provision_info_hash change for this datacluster
  // This is a read-only value.
  // googleTypes.Timestamp
  last_provision_info_hash_changed_at?: googleTypes.Timestamp;
  
  // Set if the data-cluster-provisioner found a compatible version of the dataclusterd
  // If not set the data-cluster-provisioner found an incompatible version of dataclusterd and can run into issues
  // boolean
  data_cluster_provisioner_found_compatible_dataclusterd?: boolean;
  
  // Set if the data-manager found a compatible version of the dataclusterd
  // If not set the data-manager found an incompatible version of dataclusterd and can run into issues
  // boolean
  data_manager_found_compatible_dataclusterd?: boolean;
  
  // Version of backup-manager running on this datacluster
  // string
  backup_manager_version?: string;
  
  // Version of notebook-manager on this datacluster
  // string
  notebook_manager_version?: string;
  
  // Version of ml-manager on this datacluster
  // string
  ml_manager_version?: string;
  
  // Version of auth-manager running on this datacluster.
  // string
  auth_manager_version?: string;
  
  // Version of iam-manager running on this datacluster.
  // string
  iam_manager_version?: string;
  
  // Version of sidecar-manager running on this datacluster.
  // string
  sidecar_manager_version?: string;
  
  // Version of graph_analytics_manager running on this datacluster.
  // string
  graph_analytics_manager_version?: string;
  
  // Version of test_manager running on this datacluster.
  // string
  test_manager_version?: string;
  
  // Version of logical_backup_manager running on this datacluster.
  // string
  logical_backup_manager_version?: string;
  
  // Version of chart_manager running on this datacluster.
  // string
  chart_manager_version?: string;
}

// DataClusterAssignment contains an assignment of a Deployment to a DataCluster.
export interface DataClusterAssignment {
  // Identifier of the DataCluster
  // string
  datacluster_id?: string;
  
  // Identifier of the Deployment
  // string
  deployment_id?: string;
  
  // Set when this assignment is deleted.
  // This is a read-only value.
  // boolean
  is_deleted?: boolean;
  
  // The creation timestamp of the assignment
  // This is a read-only value.
  // googleTypes.Timestamp
  created_at?: googleTypes.Timestamp;
  
  // The deletion timestamp of the assignment
  // This is a read-only value.
  // googleTypes.Timestamp
  deleted_at?: googleTypes.Timestamp;
  
  // Contains the actual provision hash of the data-cluster at the time of creation (or later update).
  // If this hash differs from the actual or target hash of the data-cluster now,
  // the deployment will go into automatic (implicit) maintenance mode.
  // This is a read-only value.
  // string
  provision_hash?: string;
  
  // If set, the provision_hash is different from the actual or target hash of the data-cluster now.
  // This is a read-only value.
  // boolean
  provision_hash_outdated?: boolean;
  
  // The timestamp of the last provision_hash change for this deployment
  // This is a read-only value.
  // googleTypes.Timestamp
  provision_hash_changed_at?: googleTypes.Timestamp;
  
  // Contains the last reported provision hash of the data-cluster for this deloyment.
  // This hash successfully made a roundtrip from controlplane to data-cluster and back to controlplane.
  // This is a read-only value.
  // string
  last_reported_provision_hash?: string;
  
  // The timestamp of the last last_reported_provision_hash change for this deployment.
  // This is a read-only value.
  // googleTypes.Timestamp
  last_reported_provision_hash_changed_at?: googleTypes.Timestamp;
}

// List of DataCluster assignments.
export interface DataClusterAssignmentList {
  // DataClusterAssignment
  items?: DataClusterAssignment[];
}

// DataClusterCostBenefits represents the (estimates) costs and benefits for a datacluster.bool
// All expressed in USD per hour.
// If a deployment is prepaid or is using credits we count them as if they are on the 'normal' paid plan.
export interface DataClusterCostBenefits {
  // The total costs in USD per hour
  // Currently this is the running instances only, in the future we want to add e.g. Persistent Volumes as well.
  // number
  total_costs?: number;
  
  // The costs in USD for the running instances (aka nodes) per hour
  // number
  instance_costs?: number;
  
  // The total benefits in USD per hour.
  // The benefits for the running deployments (fixed costs only), assuming the running deployments are on a paid plan.
  // The paused/hibernated deployments will not be taken into account.
  // number
  total_benefits?: number;
  
  // The total benefits in USD as we will invoice them per hour.
  // The benefits for the deployments (fixed costs only), free deployments are not counted, prepaid are counted as if they are on a paid plan.
  // The paused/hibernated deployments will be taken into account as we do on the invoice.
  // number
  benefits_as_invoiced?: number;
}

// DataClusterCredentials for accessing the a datacluster.
export interface DataClusterCredentials {
  // A PEM encoded representation of the public key of the CA certificate
  // used to sign client certificates.
  // string
  ca_certificate_pem?: string;
  
  // A PEM encoded representation of the public key of the client certificate.
  // string
  client_certificate_pem?: string;
  
  // A PEM encoded representation of the private key of the client certificate.
  // string
  client_certificate_key?: string;
}

// DataClusterKubeConfig for accessing the a datacluster's kubernetes API server.
export interface DataClusterKubeConfig {
  // Kube-config formatted YAML
  // string
  kube_config?: string;
}

// List of DataClusters.
export interface DataClusterList {
  // DataCluster
  items?: DataCluster[];
}

// DataClusterProvisionInfo contains all info needed to provision a datacluster
export interface DataClusterProvisionInfo {
  // Docker image to install for the data-manager
  // string
  data_manager_image?: string;
  
  // Role for the data-manager
  // string
  data_manager_role_name?: string;
  
  // URL containing yaml used to install the Kube-ArangoDB CRD's
  // string
  kube_arangodb_crds_yaml_url?: string;
  
  // Docker image containing Kube-ArangoDB operator
  // string
  kube_arangodb_image?: string;
  
  // Docker image containing ArangoDB Exporter
  // string
  arangodb_exporter_image?: string;
  
  // Docker image containing ArangoDB-Sidecar
  // string
  arangodb_sidecar_image?: string;
  
  // Docker image containing Oasis-node-init
  // string
  oasis_node_init_image?: string;
  
  // Minimum volume size for a deployment (follows kubernetes resource request format)
  // string
  minimum_deployment_volume_size?: string;
  
  // Docker image containing Promtail-sidecar
  // string
  promtail_sidecar_image?: string;
  
  // Docker image containing arango-sync
  // string
  arango_sync_image?: string;
  
  // The config for Cilium
  // CiliumProvisionInfo
  cilium?: CiliumProvisionInfo;
  
  // Docker image containing Envoy-sidecar
  // string
  envoy_sidecar_image?: string;
  
  // Flag if we should deploy node-reboot-required or not
  // boolean
  deploy_node_reboot_required?: boolean;
  
  // Docker image containing node-reboot-required
  // string
  node_reboot_required_image?: string;
  
  // Docker image containing route-manager
  // string
  route_manager_image?: string;
  
  // ID of yaml code (see idatacluster.GetYaml) used to deploy cert-manager.
  // string
  cert_manager_yaml_id?: string;
  
  // Docker image to install disk-usage-sidecar
  // string
  disk_usage_sidecar_image?: string;
  
  // Docker image to install health-manager
  // string
  health_manager_image?: string;
  
  // ID of yaml code (see idatacluster.GetYaml) used to deploy nats.
  // string
  nats_yaml_id?: string;
  
  // ID of yaml code (see idatacluster.GetYaml) used to deploy AWS LoadBalancer Controller.
  // string
  aws_loadbalancer_controller_yaml_id?: string;
  
  // ID of yaml code (see idatacluster.GetYaml) used to deploy AWS EBS CSI driver.
  // string
  aws_ebs_csi_driver_yaml_id?: string;
  
  // ID of yaml code (see idatacluster.GetYaml) used to deploy KubeRay operator.
  // string
  kube_ray_yaml_id?: string;
  
  // ID of the yaml (see idatacluster.GetYaml) used to deploy Nvidia DCGM exporter.
  // string
  dcgm_exporter_yaml_id?: string;
  
  // ID of the yaml (see idatacluster.GetYaml) used for the configutation of local-volume-provisioner.
  // string
  local_volume_provisioner_yaml_id?: string;
  
  // The config for the metrics namespace
  // MetricsProvisionInfo
  metrics?: MetricsProvisionInfo;
  
  // The period we mark a node as 'new', used to check if we need to restart (delete) pods which are in a CrashLoopBackoff and running on a new node.
  // googleTypes.Duration
  node_new_period?: googleTypes.Duration;
  
  // Docker image to install for the data-cluster-provisioner
  // Note: This information is used by the data-cluster-operator, not by the data-cluster-provisioner as the other fields in this message
  // string
  data_cluster_provisioner_image?: string;
  
  // The hash of the provision info send to the datacluster
  // string
  provision_info_hash?: string;
  
  // If set the datacluster allows reboot node operations
  // These are performed by node-reboot-required pod under management from the data-cluster-provisioner
  // Note this setting is not taken into account in the provision_info_hash
  // boolean
  reboot_nodes_allowed?: boolean;
  
  // If set this datacluster is in maintenance mode.
  // Resulting in that the data-cluster-provisioner isn't updating any resources for this
  // datacluster in the reconciliation loop anymore.
  // Note this setting is not taken into account in the provision_info_hash
  // boolean
  in_maintenance_mode?: boolean;
  
  // If set this datacluster will have Cilium Hubble enabled, otherwise it will be disabled.
  // Note this setting is not taken into account in the provision_info_hash
  // boolean
  enable_cilium_hubble?: boolean;
  
  // If set, this datacluster will have the Prometheus memory size limit set to the custom value, otherwise the default from the config map will be used.
  // Note this setting is not taken into account in the provision_info_hash
  // string
  prometheus_memory_size_limit?: string;
  
  // The volume info attributes (like type, iops and throughput) for NATS Streaming, otherwise the default from the system will be used.
  // All fields inside this message are read-only, use UpdateDataClusterVolumeInfos to update.
  // Note this setting is not taken into account in the provision_info_hash
  // VolumeInfo
  nats_streaming_volume_info?: VolumeInfo;
  
  // If set, the quantity to use for the persistent volume for NATS Streaming, otherwise the default from the system will be used.
  // (follows kubernetes resource request format)
  // This field is read-only, use UpdateDataClusterDiskSizes to update.
  // Note this setting is not taken into account in the provision_info_hash
  // string
  nats_streaming_disk_size?: string;
  
  // The volume info attributes (like type, iops and throughput) for NATS JetStream, otherwise the default from the system will be used.
  // All fields inside this message are read-only, use UpdateDataClusterVolumeInfos to update.
  // Note this setting is not taken into account in the provision_info_hash
  // VolumeInfo
  nats_jetstream_volume_info?: VolumeInfo;
  
  // If set, the quantity to use for the persistent volume for NATS JetStream, otherwise the default from the system will be used.
  // (follows kubernetes resource request format)
  // This field is read-only, use UpdateDataClusterDiskSizes to update.
  // Note this setting is not taken into account in the provision_info_hash
  // string
  nats_jetstream_disk_size?: string;
  
  // The volume info attributes (like type, iops and throughput) for Loki, otherwise the default from the system will be used.
  // All fields inside this message are read-only, use UpdateDataClusterVolumeInfos to update.
  // Note this setting is not taken into account in the provision_info_hash
  // VolumeInfo
  loki_volume_info?: VolumeInfo;
  
  // If set, the quantity to use for the persistent volume for Loki, otherwise the default from the system will be used.
  // (follows kubernetes resource request format)
  // This field is read-only, use UpdateDataClusterDiskSizes to update.
  // Note this setting is not taken into account in the provision_info_hash
  // string
  loki_disk_size?: string;
  
  // The volume info attributes (like type, iops and throughput) for Prometheus, otherwise the default from the system will be used.
  // All fields inside this message are read-only, use UpdateDataClusterVolumeInfos to update.
  // Note this setting is not taken into account in the provision_info_hash
  // VolumeInfo
  prometheus_volume_info?: VolumeInfo;
  
  // If set, the quantity to use for the persistent volume for Prometheus, otherwise the default from the system will be used.
  // (follows kubernetes resource request format)
  // This field is read-only, use UpdateDataClusterDiskSizes to update.
  // Note this setting is not taken into account in the provision_info_hash
  // string
  prometheus_disk_size?: string;
  
  // Docker image to install audit-receiver-sidecar
  // string
  audit_receiver_sidecar_image?: string;
  
  // Docker image to install audit event sender service
  // string
  audit_event_sender_image?: string;
  
  // Docker image containing bucket-manager
  // string
  bucket_manager_image?: string;
  
  // Docker image containing metrics-server
  // string
  metrics_server_image?: string;
  
  // Docker image container data_cluster_apis (crds.yaml)
  // string
  data_cluster_apis_image?: string;
  
  // Environment this datacluster is running in (e.g. "staging" or "production")
  // string
  environment?: string;
  
  // Set when this datacluster is deleted
  // Note: This setting is not taken into account in the provision_info_hash
  // boolean
  is_deleted?: boolean;
  
  // The deletion timestamp of the datacluster
  // Note: This setting is not taken into account in the provision_info_hash
  // googleTypes.Timestamp
  deleted_at?: googleTypes.Timestamp;
  
  // Readonly list of finalizers that are currently put on this datacluster
  // Note: This setting is not taken into account in the provision_info_hash
  // string
  finalizers?: string[];
  
  // Number of zones in the cluster.
  // number
  number_of_zones?: number;
  
  // Docker image containint cilium operator
  // string
  cilium_operator_image?: string;
  
  // Docker image for backup-manager
  // string
  backup_manager_image?: string;
  
  // Docker image for kubernetes-event-exporter
  // string
  kubernetes_event_exporter_image?: string;
  
  // Docker image for notebook-manager
  // string
  notebook_manager_image?: string;
  
  // Docker image for network_usage_sidecar
  // string
  network_usage_sidecar_image?: string;
  
  // Docker image for ml_manager
  // string
  ml_manager_image?: string;
  
  // Docker image for auth manager
  // string
  auth_manager_image?: string;
  
  // Docker image for data-loader manager
  // string
  data_loader_manager_image?: string;
  
  // Docker image for data-loader
  // string
  data_loader_image?: string;
  
  // Docker image for iam-manager
  // string
  iam_manager_image?: string;
  
  // Docker image for sidecar-manager
  // string
  sidecar_manager_image?: string;
  
  // Docker image for integration-sidecar
  // string
  integration_sidecar_image?: string;
  
  // Role for the iam-manager
  // string
  iam_manager_role_name?: string;
  
  // Docker image for migration-forwarder
  // string
  migration_forwarder_image?: string;
  
  // Docker image for Nvidia device plugin.
  // string
  nvidia_device_plugin_image?: string;
  
  // Docker image for graph_analytics_manager
  // string
  graph_analytics_manager_image?: string;
  
  // Docker image for test_manager
  // string
  test_manager_image?: string;
  
  // Docker image for logical_backup_manager
  // string
  logical_backup_manager_image?: string;
  
  // Docker image for envoy-init
  // string
  envoy_init_image?: string;
  
  // Docker image used for local volume provisioner (used for Local SSDs)
  // string
  local_volume_provisioner_image?: string;
  
  // Docker image for core-dump-handler
  // string
  core_dump_handler_image?: string;
  
  // Docker image for core-dump-sidecar
  // string
  core_dump_sidecar_image?: string;
  
  // Set when this datacluster has core dumps enabled (the [custom_]core_dump_filter can still be configured on an individual deployment level)
  // Note: This setting is not taken into account in the provision_info_hash
  // boolean
  is_core_dump_enabled?: boolean;
  
  // Docker image for chart-manager
  // string
  chart_manager_image?: string;
  
  // Docker image for OTEL collector
  // string
  otel_collector_image?: string;
  
  // Docker image for OTEL target allocator
  // string
  otel_target_allocator_image?: string;
}

// DefaultCustomStorageClassRequest is used to get the default custom storage class for the provided region
export interface DefaultCustomStorageClassRequest {
  // Identifier of the region for which to get the default custom storage class
  // string
  region_id?: string;
}

// DefaultCustomStorageClassResponse is the response from GetDefaultCustomStorageClassRequest
export interface DefaultCustomStorageClassResponse {
  // The name of the custom storage class (can be empty)
  // string
  custom_storage_class_name?: string;
}

// DeleteNodePoolRequest is used to delete node pool for given datacluster
export interface DeleteNodePoolRequest {
  // id of the datacluster
  // string
  datacluster_id?: string;
  
  // name of the nodepool for cloud provider
  // string
  name?: string;
}

// Number of deployments
export interface DeploymentCount {
  // number
  count?: number;
}

// Hash for deployment credentials
export interface DeploymentCredentialsHash {
  // Hash of the root password
  // string
  hash?: string;
}

// Response for GetDeploymentEmailAddresses.
export interface DeploymentEmailAddresses {
  // Addresses to send emails to for the deployment.
  // arangodb.cloud.internal.email.v1.EmailAddressList
  addresses?: arangodb_cloud_internal_email_v1_EmailAddressList;
  
  // Name of the creator of the deployment
  // string
  created_by_name?: string;
}

// All info of a Deployment - it used by the data-manager and datad
export interface DeploymentInfo {
  // The public part of a deployment
  // arangodb.cloud.data.v1.Deployment
  deployment?: arangodb_cloud_data_v1_Deployment;
  
  // If this deployment is assigned to a datacluster, this contains all info of that assignment.
  // DataClusterAssignment
  assignment?: DataClusterAssignment;
  
  // Set if the deployment is up-to-date and has no pending upgrade (this is the status info from the kube-arangodb operator).
  // boolean
  is_up_to_date?: boolean;
  
  // Kube-arangodb related settings
  // KubeArangodb
  kube_arangodb?: KubeArangodb;
  
  // If set the backups for this deployment are stored in the datacluster specific bucket (shared across multiple deployments), otherwise it uses a deployment specific bucket
  // boolean
  backups_in_datacluster_bucket?: boolean;
  
  // Set to the identifier of the audit log if auditing is enabled for this deployment, otherwise an empty string
  // string
  auditlog_id?: string;
  
  // If set to true, this deployment has a "fixed" disk size, that cannot be customised.
  // The fixed sizes are described in: https://arangodb.atlassian.net/wiki/spaces/AOI/pages/2093547548/Deployment+Model+Changes
  // Note: If the corresponding organization has `organization_info.custom_disk_settings_disabled=false`,
  // then the deployment will be allowed to update to a custom disk size.
  // boolean
  fixed_disk_size?: boolean;
  
  // List of annotations, containing free text key-value pairs
  // arangodb.cloud.internal.common.v1.KeyValuePair
  annotations?: arangodb_cloud_internal_common_v1_KeyValuePair[];
  
  // The revision of the spec part of the deployment
  // number
  revision?: number;
  
  // The last reported revision (reported back from the data-manager)
  // number
  last_reported_revision?: number;
  
  // The timestamp the revision has been last updated
  // googleTypes.Timestamp
  revision_updated_at?: googleTypes.Timestamp;
  
  // The timestamp the last_reported_revision has been last updated
  // googleTypes.Timestamp
  last_reported_revision_updated_at?: googleTypes.Timestamp;
  
  // The application/tool which created this deployment.
  // This information is collected by inspecting headers:
  // First the x-arango-graph-user-agent will be tried, if this isn't set, the first service name from oasis-trace will be used, otherwise an empty string.
  // string
  created_with?: string;
  
  // The application/tool which last updated this deployment.
  // This information is collected by inspecting headers:
  // First the x-arango-graph-user-agent will be tried, if this isn't set, the first service name from oasis-trace will be used, otherwise an empty string.
  // string
  last_updated_with?: string;
  
  // If set, the intention for this deployment is to use a shared loadbalancer.
  // Please use the network API to see the actual used loadbalancer.
  // This setting is a don't care if use_internal_loadbalancer is set.
  // boolean
  use_shared_loadbalancer?: boolean;
  
  // If set, the intention for this deployment is to use an internal loadbalancer.
  // Please use the network API to see the actual used loadbalancer.
  // This setting has preference above the use_shared_loadbalancer setting.
  // boolean
  use_internal_loadbalancer?: boolean;
  
  // If set, this deployment will not be able to receive any traffic from outside the cluster.
  // This applied to shared and dedicated LB, both public and private endpoints.
  // This can be used as a hard circuit-breaker to allow a deployment to replicate, or do other maintenance.
  // boolean
  block_all_incoming_traffic?: boolean;
  
  // Set if this deployment is in hibernation mode.
  // Resulting in that the data-manager shutdown the running deployment (arangodb pods)
  // however the deployment isn't killed and the PVCs will be preserved.
  // Note that setting this mode while in maintenance mode will have no effect.
  // A metric will be updated, so an alert can be triggered after a specific time.
  // boolean
  in_hibernation_mode?: boolean;
  
  // Set if this deployment status is full hibernated.
  // boolean
  is_hibernated?: boolean;
  
  // Set if this deployment is in maintenance mode.
  // Resulting in that the data-manager isn't updating any resources for this
  // deployment in the reconciliation loop anymore.
  // A metric will be updated, so an alert can be triggered after a specific time.
  // boolean
  in_maintenance_mode?: boolean;
  
  // The timestamp of the first time this deployment was up-to-date after the implicit maintenance mode was removed for this deployment.
  // googleTypes.Timestamp
  first_up_to_date_after_implicit_maintenance_mode_at?: googleTypes.Timestamp;
  
  // Set if the agency of this deployment is in maintenance mode.
  // boolean
  agency_in_maintenance_mode?: boolean;
  
  // List of endpoints (in format supported by arangod) that must be allowed.
  // string
  allowed_endpoints?: string[];
  
  // List of custom command line arguments for agents.
  // string
  agents_custom_command_line_arguments?: string[];
  
  // List of custom command line arguments for dbservers.
  // string
  dbservers_custom_command_line_arguments?: string[];
  
  // List of custom command line arguments for coordinatros.
  // string
  coordinators_custom_command_line_arguments?: string[];
  
  // List of custom command line arguments for gateways.
  // string
  gateways_custom_command_line_arguments?: string[];
  
  // Readonly list of finalizers that are currently put on this deployment
  // string
  finalizers?: string[];
  
  // ID of the tier of the organization that owns the deployment.
  // This is a read-only value.
  // string
  tier_id?: string;
  
  // The CPU percent ratio between components of the ArangoDB deployment.
  // This is read-only field and can be updated with UpdateDeploymentCPURatio
  // CPURatio
  cpu_ratio?: CPURatio;
  
  // [DEPRECATED] Replication settings to replicate data between ArangoDB deployments.
  // TODO: remove this in favor of `deployment_replication`.
  // Replication
  replication?: Replication;
  
  // A factor that is applied to calculate the memory & CPU resources for an
  // agency.
  // This factor is applied on the default resource size which is calculated
  // for an agency.
  // number
  agency_resources_factor?: number;
  
  // Communication method used in deployment (headless/ip)
  // string
  communication_method?: string;
  
  // List of server assignments to nodes
  // This is read-only value.
  // ServerNodeAssignment
  server_node_assignments?: ServerNodeAssignment[];
  
  // If true all servers are topology_aware and are evenly distributed across nodes.
  // This is read-only value.
  // boolean
  is_evenly_distributed?: boolean;
  
  // If true enable topology support in kube_arangodb
  // boolean
  is_topology_aware?: boolean;
  
  // Override number of zones from data cluster
  // If set to <= 0, will use value from data cluster
  // number
  number_of_zones_override?: number;
  
  // Memory reserve for agents
  // MemoryReserve
  agents_memory_reserve?: MemoryReserve;
  
  // Memory reserve for coordinators
  // MemoryReserve
  coordinators_memory_reserve?: MemoryReserve;
  
  // Memory reserve for dbservers/singles
  // MemoryReserve
  dbservers_memory_reserve?: MemoryReserve;
  
  // The memory percent ratio between components of the ArangoDB deployment.
  // This is read-only field and can be updated with UpdateDeploymentMemoryRatio
  // MemoryRatio
  memory_ratio?: MemoryRatio;
  
  // CPU resource requests and limits for agents, coordinators and db servers.
  // This is a read-only field and calculated based on the deployment model, the cpu_ratio and the cpu_factors.
  // DeploymentResources
  cpu_resources?: DeploymentResources;
  
  // Memory CPU requests and limits for agents, coordinators and db servers.
  // This is a read-only field and calculated based on the deployment model, the memory_ratio and the memory_factors.
  // DeploymentResources
  memory_resources?: DeploymentResources;
  
  // The cpu factor (0.5-1.0) between deployment and k8s resources.
  // This is a factor between the cpu defined in the deployment (ultimatily coming from node-size) and the limit and request as provided to k8s resources.
  // This is read-only field and can be updated with UpdateDeploymentCPUFactors
  // CPUFactors
  cpu_factors?: CPUFactors;
  
  // The memory factor (0.5-1.0) between deployment and k8s resources.
  // This is a factor between the memory defined in the deployment (coming from node-size) and the limit and request as provided to k8s resources.
  // This is read-only field and can be updated with UpdateDeploymentMemoryFactors
  // MemoryFactors
  memory_factors?: MemoryFactors;
  
  // A factor that is applied to calculate the memory & CPU resources for Gateways.
  // number
  gateway_resources_factor?: number;
  
  // The volume info attributes (like type, iops and throughput) for the agents
  // All fields inside this message are read-only, use UpdateDeploymentVolumeInfos to update.
  // VolumeInfo
  agents_volume_info?: VolumeInfo;
  
  // The volume info attributes (like type, iops and throughput) for the dbservers/singles
  // All fields inside this message are read-only, use UpdateDeploymentVolumeInfos to update.
  // VolumeInfo
  dbservers_volume_info?: VolumeInfo;
  
  // If set the provided storage class will be used for new persistent volume claims (PVC), if empty the 'default' storage class will be used.
  // Note that this field will work independent of dbservers_volume_info, however is recommended to align
  // (e.g. if for an existing AWS deployment the dbservers_volume_info.type is updated to 'gp3' this setting should be updated to 'gp3' as well).
  // This field is read-only, use UpdateDeploymentCustomStorageClass to update.
  // string
  custom_storage_class_name?: string;
  
  // Set if kube-arangodb operator is in maintenance mode.
  // boolean
  operator_in_maintenance_mode?: boolean;
  
  // Set if alerts are suppressed for the deployment.
  // boolean
  suppress_alerts?: boolean;
  
  // Set if the deployment uses shard rebalancer.
  // boolean
  use_shard_rebalancer?: boolean;
  
  // List of JSONPatch for arango deployment, containing operation,key,value,description information
  // arangodb.cloud.internal.common.v1.JSONPatch
  arango_deployment_patches?: arangodb_cloud_internal_common_v1_JSONPatch[];
  
  // List of JSONPatch for cloud deployment, containing operation,key,value,description information
  // arangodb.cloud.internal.common.v1.JSONPatch
  cloud_deployment_patches?: arangodb_cloud_internal_common_v1_JSONPatch[];
  
  // Replication settings to configure migration between ArangoDB Migration agent and ArangoGraph Insights Platform deployment.
  // arangodb.cloud.replication.v1.DeploymentReplication
  deployment_replication?: arangodb_cloud_replication_v1_DeploymentReplication;
  
  // A list of additional command line arguments for kube-arangodb.
  // string
  kube_arangodb_additional_command_line_arguments?: string[];
  
  // A list of id-s of scheduling policies to apply to given deployment.
  // string
  scheduling_policies_ids?: string[];
  
  // A list of scheduling policies to be applied to deployment pods
  // This is read only field
  // arangodb.cloud.internal.scheduling.v1.SchedulingPolicy
  scheduling_policies?: arangodb_cloud_internal_scheduling_v1_SchedulingPolicy[];
  
  // If set to true scheduling policies will be enabled.
  // Kept for compatibility; prefer scheduling_version (version >= 2 means enabled).
  // boolean
  scheduling_policies_enabled?: boolean;
  
  // If set to true public backups will be disabled.
  // boolean
  public_backups_disabled?: boolean;
  
  // If set, this image is used when creating a new notebook for this deployment (overriding the default notebook image).
  // `notebook_info.custom_notebook_image` is given a higher priority (if set).
  // string
  custom_notebook_image?: string;
  
  // The timestamp of when this deployment was last known to be active.
  // This is determined by monitoring the traffic coming into the deployment by users.
  // Note that this timestamp is an approximation and does not guarantee accuracy.
  // googleTypes.Timestamp
  last_active_at?: googleTypes.Timestamp;
  
  // If set, the DBServers on this deployment will use local SSD as the storage.
  // boolean
  use_local_ssd?: boolean;
  
  // If set, log every request in envoy access log
  // boolean
  enable_envoy_access_log?: boolean;
  
  // If set, the Deployment is set to read-only mode.
  // boolean
  is_read_only?: boolean;
  
  // If set this custom core dump filter should be applied
  // If not set 0x13 will be used as default, so bit: 0, 4 and 5.
  // To disable core dumps for this deployment completely, set all 9 bits to false.
  // CoreDumpFilter
  custom_core_dump_filter?: CoreDumpFilter;
  
  // If set, the Deployment is using JetStream for auditlogs.bool
  // boolean
  use_jetstream_for_auditlogs?: boolean;
  
  // Use for custom log levels for the deployment
  // MemberLogLevel
  member_log_levels?: MemberLogLevel[];
  
  // Usage item reconciliation timestamps
  // map<string, googleTypes.Timestamp>
  usage_item_reconciliation?: { [key: string]: googleTypes.Timestamp };
  
  // Desired CPU architecture for the managed ArangoDeployment: "amd64" or "arm64". Empty means default (amd64).
  // string
  target_cpu_architecture?: string;
  
  // If set, --vector-index is enabled for this deployment.
  // Sticky: once true, it must remain true (ArangoDB cannot turn the feature off on an existing data directory).
  // boolean
  vector_index_enabled?: boolean;
  
  // Scheduling version for this deployment.
  // unset / 0 / 1: legacy (same as scheduling_policies_enabled=false).
  // 2: scheduling-policies mode (same as scheduling_policies_enabled=true).
  // 3: v2 + scheduling v3 package (usable budget, gateway/LB defaults, pack affinity, etc.).
  // Updated via UpdateDeploymentSchedulingVersion (unset version means latest).
  // number
  scheduling_version?: number;
  
  // Absolute addon resource requests (gateway / dedicated LB) for scheduling v3 carve.
  // Source of truth when set (stamped from NodeSize.addon_resources on create / v3 upgrade / reapply defaults).
  // If unset, carve falls back to NodeSize.addon_resources.
  // Distinct from memory_resources/cpu_resources (computed outputs) and from memory_factors/cpu_factors (post-carve).
  // Updated via UpdateDeploymentAddonResources.
  // AddonResources
  addon_resources?: AddonResources;
  
  // Usable memory budget for the scheduling v3 carve.
  // Stamped from NodeSize.usable_memory_size on create, v3 upgrade, and reapply defaults.
  // When set, the carve uses this instead of the live NodeSize value.
  // Kubernetes quantity string, e.g. "238Gi".
  // string
  usable_memory_size?: string;
  
  // Usable CPU budget for the scheduling v3 carve.
  // Stamped from NodeSize.usable_cpu_size on create, v3 upgrade, and reapply defaults.
  // When set, the carve uses this instead of the live NodeSize value.
  // Kubernetes quantity string, e.g. "62800m".
  // string
  usable_cpu_size?: string;
  
  // Per-role pod requests for idashboard: server container request plus sidecar requests.
  // Read-only, computed by datad. cpu_resources and memory_resources stay the server container size.
  // Gateway and load balancer values match those fields; they have no ArangoDB sidecars.
  // PodResources
  pod_resources?: PodResources;
}

// List of DeploymentInfos.
export interface DeploymentInfoList {
  // Actual deployment infos
  // DeploymentInfo
  items?: DeploymentInfo[];
  
  // Budget for deployments
  // arangodb.cloud.common.v1.Budget
  budget?: arangodb_cloud_common_v1_Budget;
}

// Deployment counter for a specific model
export interface DeploymentModelCounter {
  // Identifier of the deployment model
  // string
  model_id?: string;
  
  // Name of the model
  // string
  model_name?: string;
  
  // Number of deployments using this model
  // number
  count?: number;
  
  // Number of deployments using this model in paused state
  // number
  paused?: number;
}
export interface DeploymentNetworkTransfer {
  // System identifier of the deployment.
  // This is a read-only value.
  // string
  deployment_id?: string;
  
  // The timestamp the ingress_bytes, egress_bytes, cluster_ingress_bytes and cluster_egress_bytes applies to.
  // Note that the values are reset to 0 at midnight.
  // googleTypes.Timestamp
  updated_at?: googleTypes.Timestamp;
  
  // The number of bytes the client has transferred into the system since midnight on the day as specified by updated_at.
  // This includes all traffic entering the cluster of the deployent, but the backups downloads.
  // This does not include the traffic inside the cluster.
  // number
  ingress_bytes?: number;
  
  // The number of bytes the client has transferred out of the system since midnight on the day as specified by updated_at.
  // This includes all traffic leaving the cluster of the deployent, but the backups uploads.
  // This does not include the traffic inside the cluster.
  // number
  egress_bytes?: number;
  
  // The number of bytes the deployment has transferred (ingressed) inside the cluster since midnight on the day as specified by updated_at.
  // This includes all traffic entering the cluster of the deployent, but the backups downloads.
  // This does not include the traffic inside the cluster.
  // number
  cluster_ingress_bytes?: number;
  
  // The number of bytes the deployment has transferred (egressed) inside the cluster since midnight on the day as specified by updated_at.
  // This does not include the traffic leaving the cluster.
  // number
  cluster_egress_bytes?: number;
}

// Deployment counter for a specific node size
export interface DeploymentNodeSizeCounter {
  // Identifier of the node size
  // string
  node_size_id?: string;
  
  // Name of the node size
  // string
  node_size_name?: string;
  
  // Number of deployments using this node size
  // number
  count?: number;
  
  // Number of deployments using this node size in paused state
  // number
  paused?: number;
}

// DeploymentNotificationRule keeps a notification present on every deployment matching a filter.
// Reconciled by deployment-inspector.
export interface DeploymentNotificationRule {
  // System identifier of the rule (read-only).
  // string
  id?: string;
  
  // URL of the rule (read-only).
  // string
  url?: string;
  
  // ID of the notification set on matching deployments. Required, immutable, ^[A-Z0-9_]+$.
  // string
  notification_id?: string;
  
  // Text of the notification. Required.
  // string
  notification_text?: string;
  
  // Severity of the notification.
  // arangodb.cloud.data.v1.NotificationSeverity
  severity?: arangodb_cloud_data_v1_NotificationSeverity;
  
  // Optional expiration copied onto every applied notification. A rule past this time behaves as disabled.
  // googleTypes.Timestamp
  expires_at?: googleTypes.Timestamp;
  
  // Deployments matching this filter get the notification. Empty means every deployment. `options` is ignored.
  // ListAllDeploymentsRequest
  deployment_filter?: ListAllDeploymentsRequest;
  
  // When false the notification is removed from every deployment and not re-added.
  // boolean
  enabled?: boolean;
  
  // Creation timestamp (read-only).
  // googleTypes.Timestamp
  created_at?: googleTypes.Timestamp;
  
  // Identifier of the user who created the rule (read-only).
  // string
  created_by_id?: string;
  
  // Last update timestamp (read-only).
  // googleTypes.Timestamp
  updated_at?: googleTypes.Timestamp;
  
  // Identifier of the user who last updated the rule (read-only).
  // string
  updated_by_id?: string;
  
  // DeploymentNotificationRule_Status
  status?: DeploymentNotificationRule_Status;
}

// Status reported by deployment-inspector (read-only for everyone else).
export interface DeploymentNotificationRule_Status {
  // Number of deployments in the match set at the last reconcile.
  // number
  matched?: number;
  
  // Time of the last reconcile.
  // googleTypes.Timestamp
  last_reconciled_at?: googleTypes.Timestamp;
}

// List of DeploymentNotificationRule's
export interface DeploymentNotificationRuleList {
  // DeploymentNotificationRule
  items?: DeploymentNotificationRule[];
}

// DeploymentNotificationSummary aggregates one notification ID over all deployments carrying it.
export interface DeploymentNotificationSummary {
  // ID of the notification (key in Deployment.notifications).
  // string
  notification_id?: string;
  
  // Severity of the most recently created occurrence.
  // arangodb.cloud.data.v1.NotificationSeverity
  severity?: arangodb_cloud_data_v1_NotificationSeverity;
  
  // Text of the most recently created occurrence.
  // string
  notification_text?: string;
  
  // Number of non-deleted deployments carrying the notification.
  // number
  count?: number;
  
  // Creation time of the oldest occurrence.
  // googleTypes.Timestamp
  oldest_created_at?: googleTypes.Timestamp;
  
  // Creation time of the newest occurrence.
  // googleTypes.Timestamp
  newest_created_at?: googleTypes.Timestamp;
  
  // Number of deleted deployments carrying the notification (not included in count).
  // number
  deleted_count?: number;
}

// List of DeploymentNotificationSummary's
export interface DeploymentNotificationSummaryList {
  // DeploymentNotificationSummary
  items?: DeploymentNotificationSummary[];
}

// DeploymentReplicationFactors represents min, max, avg replication factors for a deployment
export interface DeploymentReplicationFactors {
  // Identifier of the deployment to update replication factors for.
  // string
  deployment_id?: string;
  
  // Minimum replication factor considering all databases and all collections of a deployment
  // number
  minimum_replication_factor?: number;
  
  // Maximum replication factor considering all databases and all collections of a deployment
  // number
  maximum_replication_factor?: number;
  
  // Average replication factor considering all databases and all collections of a deployment
  // number
  average_replication_factor?: number;
}

// DeploymentResources defines CPU/Memory requests and limits for agents, coordinators and db servers.
// Fields should be defined as Kubernetes Resource Quotas.
// I.e.: 1Gi, 100m, 1k...
// For more information please visit https://kubernetes.io/docs/concepts/policy/resource-quotas/
export interface DeploymentResources {
  // Agent pod limits.
  // string
  agent_limits?: string;
  
  // Agent pod requests.
  // string
  agent_requests?: string;
  
  // Coordinator pod limits.
  // string
  coordinator_limits?: string;
  
  // Coordinator pod requests.
  // string
  coordinator_requests?: string;
  
  // DBServer pod limits.
  // string
  dbserver_limits?: string;
  
  // DBServer pod requests.
  // string
  dbserver_requests?: string;
  
  // Gateway pod limits.
  // string
  gateway_limits?: string;
  
  // Gateway pod requests.
  // string
  gateway_requests?: string;
  
  // Dedicated load balancer (Envoy) pod limits.
  // string
  loadbalancer_limits?: string;
  
  // Dedicated load balancer (Envoy) pod requests.
  // string
  loadbalancer_requests?: string;
}

// Organization statistics
export interface DeploymentStatistics {
  // Total number of deployments (active now)
  // number
  total?: number;
  
  // Total number of (active) deployments by tier
  // DeploymentTierCounter
  by_tier?: DeploymentTierCounter[];
  
  // Total number of deployments created today
  // number
  today?: number;
  
  // Total number of deployments created yesterday
  // number
  yesterday?: number;
  
  // Total number of deployments created in the last 7 days
  // number
  last_7days?: number;
  
  // Total number of deployments created in the entire history
  // number
  forever?: number;
  
  // Total number of paused deployments (active now)
  // number
  total_paused?: number;
  
  // Total number of (active) deployments by model
  // DeploymentModelCounter
  by_model?: DeploymentModelCounter[];
  
  // Total number of (active) deployments by support plan
  // DeploymentSupportPlanCounter
  by_support_plan?: DeploymentSupportPlanCounter[];
  
  // Total number of (active) deployments by node size
  // DeploymentNodeSizeCounter
  by_node_size?: DeploymentNodeSizeCounter[];
}

// Deployment counter for a specific support plan
export interface DeploymentSupportPlanCounter {
  // Identifier of the support plan
  // string
  support_plan_id?: string;
  
  // Name of the support plan
  // string
  support_plan_name?: string;
  
  // Number of deployments using this support plan
  // number
  count?: number;
  
  // Number of deployments using this support plan in paused state
  // number
  paused?: number;
}

// Deployment counter for a specific tier
export interface DeploymentTierCounter {
  // Identifier of the tier
  // string
  tier_id?: string;
  
  // Name of the tier
  // string
  tier_name?: string;
  
  // Number of deployments in this tier
  // number
  count?: number;
  
  // Number of deployments in this tier in paused state
  // number
  paused?: number;
}

// Result from GetDeploymentURL
export interface DeploymentURL {
  // URL of the deployment
  // string
  url?: string;
  
  // Set when this deployment is deleted.
  // boolean
  is_deleted?: boolean;
}

// DiskPerformanceInfo contains the disk performance info
export interface DiskPerformanceInfo {
  // The disk performance
  // arangodb.cloud.data.v1.DiskPerformance
  disk_performance?: arangodb_cloud_data_v1_DiskPerformance;
  
  // VolumeInfo for this disk performance
  // VolumeInfo
  volume_info?: VolumeInfo;
  
  // Weight if this disk performance, used for sorting and setting the default.
  // Higher weight comes first. The first element in the sorted list will be the default.
  // number
  weight?: number;
}

// List of DiskPerformanceInfos.
export interface DiskPerformanceInfoList {
  // DiskPerformanceInfo
  items?: DiskPerformanceInfo[];
}

// Request arguments for EstimateDeploymentUsage.
// The deployment fields mirror arangodb.cloud.data.v1.DeploymentPriceRequest, so that
// the Billing 2.0 estimate is driven by exactly the same configuration as the V1 price.
// The estimate assumes a steady state: one configuration held for the whole period, with
// no hibernation, no pause and no resize in between.
export interface EstimateDeploymentUsageRequest {
  // Identifier of the cloud provider of the deployment.
  // string
  cloud_provider_id?: string;
  
  // Identifier of the cloud region of the deployment.
  // string
  cloud_region_id?: string;
  
  // Model of the deployment.
  // string
  model?: string;
  
  // Node size used for the deployment.
  // string
  node_size_id?: string;
  
  // Number of nodes being used.
  // This field is ignored if model is "flexible".
  // number
  node_count?: number;
  
  // Amount of disk space per node (in GB).
  // This field is ignored if model is "flexible".
  // number
  node_disk_size?: number;
  
  // Number of coordinators of the deployment.
  // This field is ignored unless model is "flexible".
  // number
  coordinators?: number;
  
  // Amount of memory (in GB) to allocate for each coordinator.
  // This field is ignored unless model is "flexible".
  // number
  coordinator_memory_size?: number;
  
  // Number of dbservers of the deployment.
  // This field is ignored unless model is "flexible".
  // number
  dbservers?: number;
  
  // Amount of memory (in GB) to allocate for each dbserver.
  // This field is ignored unless model is "flexible".
  // number
  dbserver_memory_size?: number;
  
  // Amount of disk space (in GB) to allocate for each dbserver.
  // This field is ignored unless model is "flexible".
  // number
  dbserver_disk_size?: number;
  
  // Identifier of the disk performance used for this deployment (if any).
  // Selects the per-tier rate of the StoragePerformanceHour component.
  // string
  disk_performance_id?: string;
  
  // Identifier of the support plan of the deployment (applies the support factor).
  // string
  support_plan_id?: string;
  
  // ArangoDB Platform bundle of the deployment ("coredb", "aisuite", "datascience").
  // Selects the type ratio of the DeploymentAEU component, and decides whether the
  // deployment has gateway pods: as in Deployment.IsPlatformEnabled, the platform is
  // enabled for any non-empty bundle other than "coredb".
  // string
  arangodb_platform_bundle?: string;
  
  // Length of the estimated period, in hours. Defaults to 1 when zero.
  // number
  hours?: number;
  
  // Point in time the estimate applies to. Used to select the effective CreditPlan
  // version when credit_plan_id is empty. Defaults to now.
  // googleTypes.Timestamp
  at?: googleTypes.Timestamp;
  
  // Optional explicit CreditPlan to price against, e.g. the plan version being viewed.
  // When empty, no pricing is performed and only quantities are returned.
  // string
  credit_plan_id?: string;
  
  // Assumed network transfer for the period, per destination. Network usage does not
  // follow from the configuration and is entered by the caller, exactly as in the V1
  // calculator's "usage variables".
  // EstimateDeploymentUsageRequest_NetworkUsage
  network_usage?: EstimateDeploymentUsageRequest_NetworkUsage[];
  
  // Assumed size of backups in cloud storage (in GiB) held for the whole period.
  // number
  cloud_storage_gib?: number;
  
  // Assumed GPU usage over the period, in GPU-hours. GPUs are available to the AI Suite
  // and Data Science bundles, but neither how many a workload requests nor how long it
  // holds them follows from the deployment configuration, so this is an assumption of
  // the caller. Like the network figures it is a total for the period and is not scaled
  // by `hours`, which lets a GPU job that runs for part of the period be expressed.
  // number
  gpu_hours?: number;
  
  // If set, the deployment runs on a data cluster dedicated to the organization, which
  // adds the hourly AddonHour charge of the "dedicateddatacluster" addon for the period.
  // The charge is per data cluster, not per deployment.
  // boolean
  dedicated_data_cluster?: boolean;
  
  // AEU discount of the organization in percent (0-100), e.g. from its contract.
  // Applied, like in billing, only to the revenue kinds (AEU, Dedicated Data Cluster)
  // of credit plans that define revenue_usage_kinds.
  // number
  aeu_discount_percent?: number;
}

// Assumed network transfer to a single destination.
export interface EstimateDeploymentUsageRequest_NetworkUsage {
  // Destination of the transfer: "Internet" | "InCluster" | "PrivateEndpoint".
  // string
  destination?: string;
  
  // Amount transferred over the period, in GiB (ingress plus egress).
  // number
  gib?: number;
}

// Estimated Billing 2.0 usage of a deployment, optionally priced in credits.
export interface EstimatedDeploymentUsage {
  // One entry per estimated usage component. NetworkUsageSize appears once per
  // requested destination, AddonHour only for a dedicated data cluster.
  // EstimatedDeploymentUsage_Item
  items?: EstimatedDeploymentUsage_Item[];
  
  // Sum of the credits of all items that have a rate.
  // arangodb.cloud.internal.common.v1.Money
  total_credits?: arangodb_cloud_internal_common_v1_Money;
  
  // Sum of the amounts of all items that have a rate, in the system default currency.
  // arangodb.cloud.internal.common.v1.Money
  total_amount?: arangodb_cloud_internal_common_v1_Money;
  
  // CreditPlan the items were priced against. Empty when no pricing was performed.
  // string
  credit_plan_id?: string;
  
  // The deployment size the estimate was derived from.
  // arangodb.cloud.data.v1.DeploymentSize
  deployment_size?: arangodb_cloud_data_v1_DeploymentSize;
}

// A single estimated usage component.
export interface EstimatedDeploymentUsage_Item {
  // Usage kind, e.g. "CPUHour", "DeploymentAEU" (arangodb.cloud.usage.v1 kinds).
  // string
  kind?: string;
  
  // Estimated quantity in the component's natural unit.
  // number
  quantity?: number;
  
  // Human readable unit of the quantity, e.g. "core-hours", "GiB-hours".
  // string
  unit?: string;
  
  // For NetworkUsageSize: the destination this entry covers.
  // string
  network_transfer_destination?: string;
  
  // For StoragePerformanceHour: the disk performance tier the quantity is priced at.
  // string
  disk_performance_id?: string;
  
  // Cost of the quantity in credits. Zero when has_rate is false.
  // arangodb.cloud.internal.common.v1.Money
  credits?: arangodb_cloud_internal_common_v1_Money;
  
  // Cost of the quantity in the system default currency. Zero when has_rate is false.
  // arangodb.cloud.internal.common.v1.Money
  amount?: arangodb_cloud_internal_common_v1_Money;
  
  // Is there a rate for this component in the CreditPlan? False both when no pricing
  // was requested and when the plan has no matching row. An item without a rate is
  // unpriced, which is not the same as free.
  // boolean
  has_rate?: boolean;
  
  // For AddonHour: the addon this entry covers, e.g. "dedicateddatacluster".
  // string
  addon_id?: string;
}

// ExecutePackRequest starts a deployment.pack job for one pack unit.
export interface ExecutePackRequest {
  // Identifier of the deployment.
  // string
  deployment_id?: string;
  
  // Pack unit to execute (from MasterPackPlan.packs[].pack_key).
  // string
  pack_key?: string;
  
  // Boot pods confirmed in the execute dialog ("namespace/name").
  // Empty means boot nothing. Each entry must be one of the plan's pod_refs.
  // string
  boot_pod_refs?: string[];
  
  // Pull pods confirmed in the execute dialog (pod names).
  // Empty means pull nothing. Each entry must be one of the plan's pull candidates.
  // string
  restart_pod_names?: string[];
}

// Request arguments for GetDeploymentEmailAddresses.
export interface GetDeploymentEmailAddressesRequest {
  // Identifier of the deployment to get the email addresses for.
  // string
  deployment_id?: string;
}
export interface GetDeploymentURLByEndpointRequest {
  // Endpoint URL
  // string
  endpoint?: string;
}

// GetDiskPerformanceInfoRequest is used to as request in GetDiskPerformanceInfo
export interface GetDiskPerformanceInfoRequest {
  // disk performance identifier (e.g. 'DP30')
  // string
  disk_performance_id?: string;
  
  // Provider identifier (e.g. 'aws')
  // string
  provider_id?: string;
}

// GetPackPlanRequest requests the master pack plan for a deployment.
export interface GetPackPlanRequest {
  // Identifier of the deployment.
  // string
  deployment_id?: string;
}

// InstallDeploymentSchedulingDefaultsRequest re-applies NodeSize scheduling defaults for a deployment
// already on scheduling v3 (does not change scheduling_version).
export interface InstallDeploymentSchedulingDefaultsRequest {
  // Id of the deployment to update
  // string
  deployment_id?: string;
}

// Information about the volume used to store the queue data in jet stream
export interface JetStreamDataVolumeInfo {
  // The name of statefulset pod to which the volume is attached
  // string
  deployment_id?: string;
  
  // Information about the volume used to store the queue data in jet stream cluster
  // arangodb.cloud.data.v1.DataVolumeInfo
  volume_info?: arangodb_cloud_data_v1_DataVolumeInfo;
}

// Kube-arangodb related settings
export interface KubeArangodb {
  // Custom kube-arangodb image to run for the deployment (empty means the default)
  // string
  custom_kube_arangodb_image?: string;
  
  // The chaos level used for the deployment.
  // Possible values: NONE|LOW|NORMAL (an empty string means NONE)
  // string
  chaos_level?: string;
}

// Request arguments for ListAllDeployments
export interface ListAllDeploymentsRequest {
  // Common list options
  // arangodb.cloud.common.v1.ListOptions
  options?: arangodb_cloud_common_v1_ListOptions;
  
  // Return only unassigned deployments
  // boolean
  unassigned?: boolean;
  
  // Return only assigned deployments
  // boolean
  assigned?: boolean;
  
  // Return only deployments with an expiration date after this timestamp.
  // This will exclude deployments that have no expiration date.
  // googleTypes.Timestamp
  expires_after?: googleTypes.Timestamp;
  
  // Return only deployments with an expiration date before this timestamp.
  // This will exclude deployments that have no expiration date.
  // googleTypes.Timestamp
  expires_before?: googleTypes.Timestamp;
  
  // Return only deployments created in this organization.
  // string
  organization_id?: string;
  
  // Return only deployments created in this project.
  // string
  project_id?: string;
  
  // Return only deployments created in this region.
  // string
  region_id?: string;
  
  // Return only deployments that do not expire.
  // boolean
  does_not_expire?: boolean;
  
  // Return only deployments with this model.
  // string
  model?: string;
  
  // Return only deployments created in organizations that belong to this tier ID.
  // string
  tier_id?: string;
  
  // Return only deployments which match this deployment ID.
  // string
  deployment_id?: string;
  
  // Return only deployments which match this endpoint.
  // string
  endpoint?: string;
  
  // Return only deployments which are in created state.
  // boolean
  is_created?: boolean;
  
  // Return only deployments which are in upgrading state.
  // boolean
  is_upgrading?: boolean;
  
  // Return only deployments which are in ready state.
  // boolean
  is_ready?: boolean;
  
  // Return only deployments which are neither in ready, created or upgrading state.
  // boolean
  is_creating?: boolean;
  
  // Return only deployments that are assigned to the data cluster with given ID.
  // string
  datacluster_id?: string;
  
  // Return only deployments with one of these arangodb versions.
  // string
  versions?: string[];
  
  // Return only deployments with none of these arangodb versions.
  // string
  exclude_versions?: string[];
  
  // Return only deployments which are not in created state.
  // boolean
  is_not_created?: boolean;
  
  // Return only deployments which are not in upgrading state.
  // boolean
  is_not_upgrading?: boolean;
  
  // Return only deployments which are not in ready state.
  // boolean
  is_not_ready?: boolean;
  
  // Return only deployments which are either in ready, created or upgrading state.
  // boolean
  is_not_creating?: boolean;
  
  // Request deployments that are created at or after this timestamp.
  // This is an optional field.
  // googleTypes.Timestamp
  from?: googleTypes.Timestamp;
  
  // Request deployments that are created before this timestamp.
  // This is an optional field.
  // googleTypes.Timestamp
  to?: googleTypes.Timestamp;
  
  // Return only deployments which are paused.
  // boolean
  is_paused?: boolean;
  
  // Return only deployments which are not paused.
  // boolean
  is_not_paused?: boolean;
  
  // Return only deployments which are in maintenance mode.
  // boolean
  is_in_maintenance_mode?: boolean;
  
  // Return only deployments which are not in maintenance mode.
  // boolean
  is_not_in_maintenance_mode?: boolean;
  
  // Return only deployments which are in hibernated state.
  // boolean
  is_hibernated?: boolean;
  
  // Return only deployments which are not in hibernated state.
  // boolean
  is_not_hibernated?: boolean;
  
  // Return only deployments which are in hibernation mode.
  // boolean
  is_in_hibernation_mode?: boolean;
  
  // Return only deployments which are not in hibernation mode.
  // boolean
  is_not_in_hibernation_mode?: boolean;
  
  // Return only deployments which are in deleting state.
  // boolean
  is_deleting?: boolean;
  
  // Return only deployments which are not in deleting state.
  // boolean
  is_not_deleting?: boolean;
  
  // Return only deployments using the support plan with this ID.
  // string
  support_plan_id?: string;
  
  // Return only deployments using the node size with this ID.
  // string
  node_size_id?: string;
  
  // Return only deployments that disk_auto_size_settings allow disk to grow.
  // boolean
  can_grow_disk_only?: boolean;
  
  // Return only deployments created in one of these regions.
  // string
  region_ids?: string[];
  
  // Return only deployments using a node size with one of these IDs.
  // string
  node_size_ids?: string[];
  
  // Return only deployments whose last password rotation was before this time.
  // googleTypes.Timestamp
  last_password_rotated_at_before?: googleTypes.Timestamp;
  
  // Return deployments which have scheduled root password rotation enabled.
  // boolean
  is_scheduled_root_password_rotation_enabled?: boolean;
  
  // Return deployments which have scheduled root password rotation disabled.
  // boolean
  is_not_scheduled_root_password_rotation_enabled?: boolean;
  
  // Return only deployments that currently carry a notification with this ID.
  // string
  notification_id?: string;
}

// ListAllDiskPerformancesRequest is used to as request in ListAllDiskPerformances
export interface ListAllDiskPerformancesRequest {
  // Optional provider identifier to filter on
  // string
  provider_id?: string;
}

// Options for ListDataClusters
export interface ListDataClusterOptions {
  // Standard list options
  // arangodb.cloud.common.v1.ListOptions
  options?: arangodb_cloud_common_v1_ListOptions;
  
  // If set, filter on the provider_id of data cluster
  // string
  provider_ids?: string[];
  
  // If set, filter on the region_id of data cluster
  // string
  region_ids?: string[];
  
  // If set, filter on the data cluster having at least this label
  // string
  label?: string;
}

// ListNodePoolsRequest is used to request information about node pools for given datacluster
export interface ListNodePoolsRequest {
  // Standard list options
  // arangodb.cloud.common.v1.ListOptions
  options?: arangodb_cloud_common_v1_ListOptions;
  
  // ID of the datacluster to get information about node pools for
  // This field is required
  // string
  datacluster_id?: string;
}
export interface LogLevelList {
  // List of log levels
  // MemberLogLevel
  items?: MemberLogLevel[];
}

// MasterPackPlan lists pack units for a deployment (one prmr+crdn+gway+lb per unit).
export interface MasterPackPlan {
  // Identifier of the deployment.
  // string
  deployment_id?: string;
  
  // Short human-readable overview for operators.
  // string
  summary?: string;
  
  // Individual pack units; may include several in the same availability zone.
  // PackPlan
  packs?: PackPlan[];
}
export interface MemberLogLevel {
  // Topic name
  // string
  topic?: string;
  
  // Topic log level
  // string
  level?: string;
  
  // Member role type (e.g. agent, coordinator, dbserver)
  // string
  role?: string;
  
  // optional date when the log level should be reverted to the default value
  // googleTypes.Timestamp
  expire_at?: googleTypes.Timestamp;
}

// MemoryFactors defines independent multipliers applied to calculated memory requests per role.
// On scheduling v3 these multiply the post-carve base (default 1.0 after upgrade).
// Allowed range is typically 0.5–2.0 (enforced by datad).
export interface MemoryFactors {
  // Memory factor for coordinator. Default is 1.0.
  // number
  coordinator_factor?: number;
  
  // Memory factor for DB server (also used for single-server). Default is 1.0.
  // number
  dbserver_factor?: number;
  
  // Memory factor for gateway. Default is 1.0. Unused when platform/gateway is off.
  // number
  gateway_factor?: number;
  
  // Memory factor for dedicated load balancer. Default is 1.0. Unused with shared LB.
  // number
  loadbalancer_factor?: number;
}

// MemoryRatio of percents for coordinator and dbserver.
// The sum of all values should be 100.
// All values must be > 0 and < 100.
export interface MemoryRatio {
  // A memory percent for coordinator.
  // number
  coordinator_percent?: number;
  
  // A memory percent for DB server.
  // number
  dbserver_percent?: number;
}

// MemoryRequestToLimitSpec holds the ratio from memory request to memory limit.
// E.g. A value of 2 means that a request of 1Gb yields a limit of 2Gb.
// All ratios must be >= 1.
export interface MemoryRequestToLimitSpec {
  // Memory request to limit ratio for agents
  // string
  agents?: string;
  
  // Memory request to limit ratio for coordinators
  // string
  coordinators?: string;
  
  // Memory request to limit ratio for dbservers
  // string
  dbservers?: string;
  
  // Memory request to limit ratio for gateways
  // string
  gateways?: string;
  
  // Memory request to limit ratio for dedicated load balancers (optional)
  // string
  loadbalancers?: string;
}

// MemoryReserve specifies memory reserves for one of the deployment components (agents, coordinators, dbservers)
// MemoryReserve lowers component's memory override to (total - absolute) * (1 - relative/100)
export interface MemoryReserve {
  // Absolute is an absolute memory reserve in bytes
  // This value is subtracted from total memory value specified in deployment.
  // number
  absolute?: number;
  
  // Relative is a percentage of total memory after subtraction of absolute reserve that should be additionally subtracted from total memory
  // This value should be between 0 and 100
  // number
  relative?: number;
  
  // Set to true if the values of the MemoryReserve are the default values.
  // If memory reserves are overridden, this value will be false.
  // boolean
  is_default?: boolean;
}

// MemoryToCPUSpec holds the ratio from memory to CPU request.
// E.g. A value of 8 means that you get 1vCPU for every 8GB of memory.
// All ratios must be > 0.
export interface MemoryToCPUSpec {
  // Memory to CPU ratio for agents
  // string
  agents?: string;
  
  // Memory to CPU ratio for coordinators
  // string
  coordinators?: string;
  
  // Memory to CPU ratio for dbservers
  // string
  dbservers?: string;
  
  // Memory to CPU ratio for gateways
  // string
  gateways?: string;
  
  // Memory to CPU ratio for dedicated load balancers (optional)
  // string
  loadbalancers?: string;
}

// Metrics related info
export interface MetricsInfo {
  // Version of Prometheus
  // string
  prometheus_version?: string;
  
  // Prometheus scrape targets
  // MetricsInfo_ScrapeTargets
  prometheus_scrape_targets?: MetricsInfo_ScrapeTargets;
  
  // Prometheus rules status
  // MetricsInfo_PrometheusRulesStatus
  prometheus_rules_status?: MetricsInfo_PrometheusRulesStatus;
  
  // Prometheus alert status
  // MetricsInfo_PrometheusAlertStatus
  prometheus_alert_status?: MetricsInfo_PrometheusAlertStatus;
  
  // The timestamp of the first sample in the system
  // googleTypes.Timestamp
  first_sample_at?: googleTypes.Timestamp;
  
  // The timestamp of the last sample in the system
  // googleTypes.Timestamp
  last_sample_at?: googleTypes.Timestamp;
  
  // The total number of samples in the system
  // number
  total_number_of_samples?: number;
  
  // Information about the volume used to store the data for prometheus
  // arangodb.cloud.data.v1.DataVolumeInfo
  prometheus_data_volume_info?: arangodb_cloud_data_v1_DataVolumeInfo;
  
  // Version of Alertmanager
  // string
  alertmanager_version?: string;
  
  // Number of active Alertmanagers
  // number
  alertmanagers_active?: number;
  
  // Number of dropped Alertmanagers
  // number
  alertmanagers_dropped?: number;
  
  // Version of Loki
  // string
  loki_version?: string;
  
  // Information about the volume used to store the data for loki
  // arangodb.cloud.data.v1.DataVolumeInfo
  loki_data_volume_info?: arangodb_cloud_data_v1_DataVolumeInfo;
  
  // Version of Promtail
  // string
  promtail_version?: string;
  
  // The total number of log lines entered into the system since restart of loki
  // number
  log_lines_total?: number;
  
  // Information about Nats
  // arangodb.cloud.data.v1.DataVolumeInfo
  nats_data_volume_info?: arangodb_cloud_data_v1_DataVolumeInfo;
  
  // Information about the volume used to store the queue data in jet stream
  // JetStreamDataVolumeInfo
  nats_jetstream_data_volume_info?: JetStreamDataVolumeInfo[];
}

// Status about alerts for Prometheus
export interface MetricsInfo_PrometheusAlertStatus {
  // Number of pending alerts
  // number
  pending?: number;
  
  // Number of firing alerts
  // number
  firing?: number;
  
  // Info about firing alerts
  // MetricsInfo_PrometheusFiringAlert
  firing_info?: MetricsInfo_PrometheusFiringAlert[];
}

// Info about a single firing alert
export interface MetricsInfo_PrometheusFiringAlert {
  // Name of the alert
  // string
  name?: string;
  
  // The start date of this alert
  // googleTypes.Timestamp
  active_at?: googleTypes.Timestamp;
  
  // The current value of the alert
  // string
  value?: string;
  
  // The 'for' value of the alert (if any)
  // googleTypes.Duration
  for?: googleTypes.Duration;
  
  // The datacluster ID (if bound to a datacluster)
  // string
  datacluster_id?: string;
  
  // The deployment ID (if bound to a deployment)
  // string
  deployment_id?: string;
  
  // The runbook URL (if available)
  // string
  runbook_url?: string;
  
  // The severity associated to this alert
  // string
  severity?: string;
  
  // The category associated to this alert
  // string
  category?: string;
  
  // The PromQL associated to this alert
  // string
  promql?: string;
  
  // The deployment model (if bound to a deployment)
  // string
  deployment_model?: string;
  
  // The deployment support plan ID (if bound to a deployment)
  // string
  deployment_supportplan_id?: string;
  
  // Optional context related to this alert
  // string
  context?: string;
  
  // Set when this alert is suppressed (and not forwarded to OpsGenie)
  // E.g. when the severity is 'error' or 'critical' and the deployment model is 'developer'
  // boolean
  is_suppressed?: boolean;
  
  // The notification channel value set for this alert (if any)
  // E.g. 'noslack'
  // string
  notification_channel?: string;
  
  // When set it silences the alert
  // boolean
  is_silenced?: boolean;
}

// Status about rules for Prometheus
export interface MetricsInfo_PrometheusRulesStatus {
  // Number of healthy rules
  // number
  health_ok?: number;
  
  // Number of error rules
  // number
  health_error?: number;
  
  // Number of unknown rules
  // number
  health_unknown?: number;
  
  // Number of recording rules
  // number
  type_recording?: number;
  
  // Number of alerting rules
  // number
  type_alerting?: number;
}

// Scrape targets for Prometheus
export interface MetricsInfo_ScrapeTargets {
  // Number of active scrape targets
  // number
  active?: number;
  
  // Number of active scrape targets which are up
  // number
  active_up?: number;
  
  // Number of active scrape targets which are down
  // number
  active_down?: number;
  
  // Number of active scrape targets which are down
  // number
  active_unknown?: number;
}

// Nested response inside GetProvisionInfoResponse containing all info for Provisioning the metrics namespace
export interface MetricsProvisionInfo {
  // Docker image containing Prometheus operator
  // string
  prometheus_operator_image?: string;
  
  // URL containing yaml used to install the Prometheus Operator CRD's
  // string
  prometheus_operator_crds_yaml_url?: string;
  
  // Docker image containing Prometheus Config reloader (operator argument)
  // string
  prometheus_config_reloader_image?: string;
  
  // Docker image containing ConfigMap reload (operator argument)
  // string
  configmap_reload_image?: string;
  
  // URL that prometheus must remote-write its data to.
  // string
  prometheus_remote_write_url?: string;
  
  // Hash of credentials used for prometheus remote write authentication
  // string
  prometheus_remote_write_credentials_hash?: string;
  
  // Image of Prometheus, which will be used by Prometheus operator
  // string
  prometheus_image?: string;
  
  // Version of Prometheus, which will be used by Prometheus operator
  // string
  prometheus_version?: string;
  
  // A string containing YamlBlock ID for PrometheusRules resources.
  // string
  prometheus_rules_yaml_id?: string;
  
  // The memory size limit for Prometheus (follows kubernetes resource Quantity format)
  // string
  prometheus_memory_size_limit?: string;
  
  // Image of Alertmanager, which will be used by Prometheus operator
  // string
  alertmanager_image?: string;
  
  // Version of Alertmanager, which will be used by Prometheus operator
  // string
  alertmanager_version?: string;
  
  // The YamlBlock ID for config for Alertmanager, which will be placed in a Secret (alertmanager-alertmanager)
  // string
  alertmanager_config_yaml_id?: string;
  
  // The YamlBlock ID for template data for Alertmanager, which will be placed in a ConfigMap (alertmanager-template) and can be referenced in the alertmanager_config
  // string
  alertmanager_template_data_yaml_id?: string;
  
  // Docker image containing node-exporter
  // string
  node_exporter_image?: string;
  
  // Docker image containing kube-state-metrics
  // string
  kube_state_metrics_image?: string;
  
  // Docker image containing kube-rbac-proxy
  // string
  kube_rbac_proxy_image?: string;
  
  // Docker image containing addon-resizer
  // string
  addon_resizer_image?: string;
  
  // Docker image containing loki
  // string
  loki_image?: string;
  
  // Quantity to use for the persistent volume for loki (follows kubernetes resource request format)
  // string
  loki_disk_size?: string;
  
  // The YamlBlock ID for config for loki, which will be placed in a ConfigMap
  // string
  loki_config_data_yaml_id?: string;
  
  // Docker image containing promtail
  // string
  promtail_image?: string;
  
  // The YamlBlock ID for config for promtail, which will be placed in a ConfigMap
  // string
  promtail_config_data_yaml_id?: string;
  
  // The YamlBlock ID for config for promtail centralized, which will be placed in a ConfigMap
  // string
  promtail_centralized_config_data_yaml_id?: string;
  
  // Docker image containing promtail config reloader image
  // string
  promtail_config_reloader_image?: string;
  
  // Docker image containing alloy-dc
  // string
  alloy_datacluster_image?: string;
  
  // Docker image containing alloy-dc config reloader
  // string
  alloy_datacluster_config_reloader_image?: string;
  
  // The YamlBlock ID for config for alloy detacluster which will be placed in a ConfigMap
  // string
  alloy_datacluster_config_data_yaml_id?: string;
  
  // If set the kubelet (in the namespace 'kube-system') is scraped (to collect cAdvisor data)
  // boolean
  scrape_kubelet?: boolean;
  
  // If set the kube API server (in the namespace 'default') is scraped
  // boolean
  scrape_api_server?: boolean;
  
  // Docker image containing alloy-cp
  // string
  alloy_controlplane_image?: string;
  
  // Docker image containing alloy-cp config reloader
  // string
  alloy_controlplane_config_reloader_image?: string;
  
  // The YamlBlock ID for config for alloy cp which will be placed in a ConfigMap
  // string
  alloy_controlplane_config_data_yaml_id?: string;
}

// ModelLimitation defines limitations of a node size for a specific deployment model.
export interface ModelLimitation {
  // ID of the deployment model for which these limits apply.
  // string
  model?: string;
  
  // If set, this node size cannot be used for new deployments using this deployment model.
  // boolean
  unavailable?: boolean;
  
  // Optional IDs of the tiers for which these limits apply.
  // If not specified all tiers are used.
  // string
  tier_ids?: string[];
}

// All info of a (worker-)node.
export interface Node {
  // Kubernetes name of the node
  // string
  name?: string;
  
  // The timestamp of the creation of the node
  // googleTypes.Timestamp
  created_at?: googleTypes.Timestamp;
  
  // Status of the node
  // string
  status?: string;
  
  // Detailed info of the node
  // NodeInfo
  info?: NodeInfo;
  
  // Total resource capacity of the node
  // NodeResources
  capacity?: NodeResources;
  
  // Total allocatable resource capacity of the node
  // NodeResources
  allocatable?: NodeResources;
  
  // Used capacity of the node.
  // The values of this field are read-only and auto-calculated.
  // NodeUsage
  usage?: NodeUsage;
  
  // Current condition of the node
  // NodeConditionList
  conditions?: NodeConditionList;
  
  // Currently allocated resources of the node
  // NodeResources
  allocated?: NodeResources;
  
  // If set, the node is part of Scheduling V2
  // boolean
  scheduling_v2?: boolean;
  
  // Slim inventory of pods currently scheduled on this node.
  // NodePod
  pods?: NodePod[];
}

// Individual condition of a node.
export interface NodeCondition {
  // Type of the condition
  // string
  type?: string;
  
  // Value of the condition. False good, true is bad.
  // boolean
  value?: boolean;
  
  // Human readable reason for the value of the condition.
  // string
  reason?: string;
}

// Condition flags of a node.
// For all conditions, false is good, true is bad.
export interface NodeConditionList {
  // NodeCondition
  items?: NodeCondition[];
}

// Environmental info of a node
export interface NodeInfo {
  // Type of instance of the node
  // string
  instanceType?: string;
  
  // Name of node pool/group the node is a part of
  // string
  groupName?: string;
  
  // Availability zone the node is in
  // string
  zone?: string;
  
  // CPU architecture of the node
  // string
  architecture?: string;
  
  // Version of the container runtime on the node
  // string
  containerRuntimeVersion?: string;
  
  // Version of kube-proxy on the node
  // string
  kubeProxyVersion?: string;
  
  // Version of kubelet on the node
  // string
  kubeletVersion?: string;
  
  // Version of kernel on the node
  // string
  kernelVersion?: string;
  
  // Name of OS on the node
  // string
  operatingSystem?: string;
  
  // Name of OS image used for the node
  // string
  osImage?: string;
}

// List of Nodes.
export interface NodeList {
  // Node
  items?: Node[];
}

// Slim summary of a pod on a worker node (not a full Pod spec).
export interface NodePod {
  // Kubernetes pod name
  // string
  name?: string;
  
  // Kubernetes namespace
  // string
  namespace?: string;
  
  // Pod phase (Pending, Running, Succeeded, Failed, Unknown)
  // string
  phase?: string;
  
  // True when the Ready condition is true
  // boolean
  ready?: boolean;
  
  // Pod QoS class (Guaranteed, Burstable, BestEffort)
  // string
  qos_class?: string;
  
  // Sum of container CPU requests
  // string
  cpu_request?: string;
  
  // Sum of container memory requests
  // string
  memory_request?: string;
  
  // Controller kind if owned (Deployment, StatefulSet, DaemonSet, ...)
  // string
  controller_kind?: string;
  
  // Controller name if owned
  // string
  controller_name?: string;
  
  // Selected labels useful for ops (prefer a small allowlist when collecting)
  // map<string, string>
  labels?: { [key: string]: string };
}

// NodePool information.
export interface NodePool {
  // id of the datacluster that given nodepool is attached to
  // string
  datacluster_id?: string;
  
  // name of the nodepool as visible in provider console
  // string
  name?: string;
  
  // zone that this nodepool nodes will be running in
  // string
  zone?: string;
  
  // provider's server type
  // string
  provider_server_type?: string;
  
  // number of instances to run, if set to 0 it will use whatever requested
  // number
  instance_count?: number;
  
  // NodePool_Status
  status?: NodePool_Status;
}

// Contains information about NodePool Status
export interface NodePool_Status {
  // labels contains kubernetes labels for nodes in this nodepool
  // arangodb.cloud.internal.common.v1.KeyValuePair
  labels?: arangodb_cloud_internal_common_v1_KeyValuePair[];
  
  // taints contains kubernetes taints for nodes in this nodepool
  // arangodb.cloud.internal.common.v1.KeyValuePair
  taints?: arangodb_cloud_internal_common_v1_KeyValuePair[];
  
  // number of requested instances to run
  // number
  requested_instances?: number;
  
  // number of currently running instances
  // number
  running_instances?: number;
  
  // last update timestamp
  // googleTypes.Timestamp
  last_update?: googleTypes.Timestamp;
  
  // price per hour in USD for running instances of this type
  // number
  instance_price_per_hour?: number;
  
  // number of cpu vcores
  // number
  cpu?: number;
  
  // amount of memory in MibiBytes
  // number
  memory_mb?: number;
  
  // cpu architecture
  // string
  arch?: string;
  
  // gpu instances
  // number
  gpu?: number;
  
  // maximum number of pods that can be scheduled on nodes from given node pool
  // number
  max_pods?: number;
  
  // status message from provider
  // string
  status?: string;
}

// NodePoolList contains a list of NodePools
export interface NodePoolList {
  // NodePool
  items?: NodePool[];
}

// Allocatable or capacity of a node in kubernetes quantities.
export interface NodeResources {
  // CPU quantity
  // string
  cpu?: string;
  
  // Memory quantity
  // string
  memory?: string;
  
  // Storage quantity
  // string
  ephemeralStorage?: string;
  
  // Max number of attachable volumes quantity
  // string
  attachableVolumes?: string;
  
  // Max number of schedulable pods quantity
  // string
  pods?: string;
}

// NodeSizeDetails defines internal details of a NodeSize.
export interface NodeSizeDetails {
  // Human readable name of this node size
  // string
  name?: string;
  
  // Amount of memory (in GB) available on the node.
  // number
  memory_size?: number;
  
  // Minimum amount of disk space (in GB) to available on the node.
  // number
  min_disk_size?: number;
  
  // Maximum amount of disk space (in GB) to available on the node.
  // number
  max_disk_size?: number;
  
  // Size of CPU this node size yields (e.g. standard or high)
  // string
  cpu_size?: string;
  
  // Ratio from memory to CPU request.
  // E.g. A value of 8 means that you get 1vCPU for every 8GB of memory.
  // MemoryToCPUSpec
  memory_to_cpu?: MemoryToCPUSpec;
  
  // Ratio from CPU request to CPU limit.
  // E.g. A value of 2 means that a request of 1vCPU yields a limit of 2vCPU.
  // CPURequestToLimitSpec
  cpu_request_to_limit?: CPURequestToLimitSpec;
  
  // Weight of this node size, used for sorting.
  // Note that node sizes are sorted by memory first, then by weight (higher weight comes first).
  // number
  weight?: number;
  
  // If set, this node size cannot be used for new deployments.
  // boolean
  unavailable?: boolean;
  
  // If set, this node size can only be used by organizations with given IDs.
  // string
  organizationIds?: string[];
  
  // Limitations for this node size on specific cloud providers.
  // ProviderLimitation
  provider_limitations?: ProviderLimitation[];
  
  // Limitations for this node size on specific deployment models.
  // ModelLimitation
  model_limitations?: ModelLimitation[];
  
  // Ratio from memory request to memory limit.
  // E.g. A value of 2 means that a request of 1Gb yields a limit of 2Gb.
  // MemoryRequestToLimitSpec
  memory_request_to_limit?: MemoryRequestToLimitSpec;
  
  // If set, this node size does NOT support the disk performances provided by one of these given IDs.
  // These IDs applies to all providers/regions.
  // string
  excluded_disk_performance_ids?: string[];
  
  // If set, these scheduling policies will be applied to deployment
  // string
  scheduling_policies_ids?: string[];
  
  // If set, these are default CPU factors for deployment when their scheduling policies are not empty
  // CPUFactors
  default_cpu_factors?: CPUFactors;
  
  // If set, these are default memory factors for deployment when their scheduling policies are not empty
  // MemoryFactors
  default_memory_factors?: MemoryFactors;
  
  // Fixed disk performance setting for this node size.
  // If unspecified, the defaults are loaded from the DiskPerformances specified in the CP.
  // If organizations are explicitly allowed to have custom disk settings, they may
  // configure other DP settings (excluding the ones specified in ExcludedDiskPerformanceIDs).
  // Note: To override this setting based on the cloud provider/region,
  // it needs to be specified in `provider_limitations.disk_performances`.
  // string
  disk_performance_id?: string;
  
  // Usable memory available for workload pods after system / kubelet overhead.
  // Used by scheduling v3 sizing; if unset, consumers fall back to memory_size.
  // Kubernetes quantity string, e.g. "13.5Gi".
  // string
  usable_memory_size?: string;
  
  // Absolute default resource requests for optional addons (gateway, dedicated LB).
  // Used by scheduling v3 carve as catalog defaults; stamped onto DeploymentInfo.addon_resources.
  // Distinct from default_memory_factors (post-carve multipliers).
  // Values are k8s request quantities (not request/limit pairs).
  // AddonResources
  addon_resources?: AddonResources;
  
  // Usable CPU available for workload pods after system / kubelet overhead.
  // Used by scheduling v3 sizing; if unset, consumers derive from memory_size / memory_to_cpu.
  // Kubernetes quantity string, e.g. "3400m".
  // string
  usable_cpu_size?: string;
}

// Percentage of resources of a node that is currently in use.
// All values are between 0.0 (0%) and 1.0 (100%).
export interface NodeUsage {
  // CPU usage
  // number
  cpu?: number;
  
  // Memory usage
  // number
  memory?: number;
  
  // Storage usage
  // number
  ephemeralStorage?: number;
  
  // Usage of attachable volumes capacity
  // number
  attachableVolumes?: number;
  
  // Usage of schedulable pods capacity
  // number
  pods?: number;
}

// PackBootSetPreview is the boot portion of the default pack plan.
// pod_refs are the pods shown in the execute dialog. This deployment's member pods come
// first, then other deployments' member pods, then platform pods.
// default_selected_pod_refs is the platform subset that starts checked.
// Any pod_ref may be confirmed for boot, including member pods.
export interface PackBootSetPreview {
  // Number of platform pods in pod_refs. Member pods are not counted.
  // number
  pod_count?: number;
  
  // Short sample of the platform pods for compact display. Prefer pod_refs for the execute dialog.
  // string
  sample_pod_names?: string[];
  
  // string
  note?: string;
  
  // Pods on the target node, "namespace/name".
  // Excludes DaemonSets and node-bound pods (such as kube-proxy).
  // Member pods (dbserver, coordinator, agent, gateway, load-balancer) are included
  // and can be selected. They are recognized by role, not by namespace prefix.
  // string
  pod_refs?: string[];
  
  // Subset of pod_refs selected by default: platform pods. Member pods are omitted.
  // string
  default_selected_pod_refs?: string[];
}

// PackMemberPlacement is current placement of one member in a pack unit.
export interface PackMemberPlacement {
  // kube-arangodb server id when applicable.
  // string
  server_id?: string;
  
  // string
  pod_name?: string;
  
  // string
  node_name?: string;
  
  // string
  role?: string;
}

// PackPlan describes one pack unit and the work required to pack it.
export interface PackPlan {
  // Stable identifier for ExecutePack and deployment.pack job custom fields.
  // string
  pack_key?: string;
  
  // PackPlanStatus
  status?: PackPlanStatus;
  
  // One-line description for UI rows.
  // string
  summary?: string;
  
  // Proposed target Kubernetes node for this pack (empty when unknown or ineligible).
  // string
  target_node_name?: string;
  
  // Availability zone when known (sibling packs may share an AZ).
  // string
  availability_zone?: string;
  
  // PackMemberPlacement
  dbserver?: PackMemberPlacement;
  
  // PackMemberPlacement
  coordinator?: PackMemberPlacement;
  
  // PackMemberPlacement
  gateway?: PackMemberPlacement;
  
  // PackMemberPlacement
  load_balancer?: PackMemberPlacement;
  
  // PackBootSetPreview
  boot_set?: PackBootSetPreview;
  
  // True when the dbserver is on the correct node size (outside-budget scaling considered).
  // boolean
  dbserver_on_correct_node_size?: boolean;
  
  // When dbserver_on_correct_node_size is false, a short explanation.
  // string
  dbserver_node_size_note?: string;
}

// PodResources is the per-role pod request.
// Coordinator, DB server, single, and agent values include sidecar requests.
// Gateway and load balancer values are the pod carve.
export interface PodResources {
  // Coordinator pod CPU request.
  // string
  coordinator_cpu?: string;
  
  // Coordinator pod memory request.
  // string
  coordinator_memory?: string;
  
  // DB server or single server pod CPU request.
  // string
  dbserver_cpu?: string;
  
  // DB server or single server pod memory request.
  // string
  dbserver_memory?: string;
  
  // Agent pod CPU request.
  // string
  agent_cpu?: string;
  
  // Agent pod memory request.
  // string
  agent_memory?: string;
  
  // Gateway pod CPU request.
  // string
  gateway_cpu?: string;
  
  // Gateway pod memory request.
  // string
  gateway_memory?: string;
  
  // Dedicated load balancer pod CPU request.
  // string
  loadbalancer_cpu?: string;
  
  // Dedicated load balancer pod memory request.
  // string
  loadbalancer_memory?: string;
}

// How many pods are in a given state.
// Depending of the usage the cluster can be global or namespace bound.
export interface PodStatistics {
  // Total number of pods in the cluster
  // number
  total?: number;
  
  // Number of pods in the cluster that are in Pending phase
  // number
  pending?: number;
  
  // Number of pods in the cluster that are in Running phase
  // number
  running?: number;
  
  // Number of pods in the cluster that are in Succeeded phase
  // number
  succeeded?: number;
  
  // Number of pods in the cluster that are in Failed phase (and reason not Evicted)
  // number
  failed?: number;
  
  // Number of pods in the cluster that have a positive Scheduled condition
  // number
  scheduled?: number;
  
  // Number of pods in the cluster that have a positive Ready condition
  // number
  ready?: number;
  
  // Number of pods in the cluster that have a positive Initialized condition
  // number
  initialized?: number;
  
  // Number of pods in the cluster that have a positive Unschedulable condition
  // number
  unschedulable?: number;
  
  // Number of pods in the cluster that are in Failed phase (and reason Evicted)
  // number
  evicted?: number;
  
  // Number of pods in the cluster that are in Waiting phase and reason CrashLoopBackoff
  // number
  crashloopbackoff?: number;
  
  // Longest any pod in the cluster has been running but not ready (in seconds)
  // number
  longest_not_ready_time_in_sec?: number;
}

// The pod statistics in a single namespace
export interface PodStatisticsInNamespace {
  // The namespace the pod statistics applied to
  // string
  namespace?: string;
  
  // Pod statistics on the cluster for the specified namespace
  // PodStatistics
  pod_statistics?: PodStatistics;
}

// Credentials used by Prometheus on datacluster to authenticate its remote write connection
// to the central cortex.
export interface PrometheusRemoteWriteCredentials {
  // Username part of the authentication
  // string
  username?: string;
  
  // Password part of the authentication
  // string
  password?: string;
}

// ProviderLimitation defines limitations of a node size for a specific cloud provider.
export interface ProviderLimitation {
  // ID of the provider for which these limits apply.
  // string
  provider_id?: string;
  
  // If set, this node size cannot be used for new deployments on this provider.
  // boolean
  unavailable?: boolean;
  
  // If set, limits the node to use only disk of these sizes (in GB).
  // In that case, this field overrides the min_disk_size & max_disk_size fields of NodeSizeDetails.
  // number
  disk_sizes?: number[];
  
  // Optional IDs of the regions for which these limits apply.
  // The region(s) should match the provider
  // If not specified all regions of the providers are used.
  // string
  region_ids?: string[];
  
  // If set, this node size does NOT support the disk performances provided by one of these given IDs for this provider/region.
  // These IDs will be on top of those specified on NodeSizeDetails level (resulting in the union of the two slices)
  // string
  excluded_disk_performance_ids?: string[];
  
  // If set, do not automatically propagate scheduling policies on given provider
  // boolean
  disable_scheduling_policies_propagation?: boolean;
  
  // If set, these are default CPU factors for deployment when their scheduling policies are not empty
  // those values will override default_cpu_factors on node level
  // CPUFactors
  default_cpu_factors?: CPUFactors;
  
  // If set, these are default memory factors for deployment when their scheduling policies are not empty
  // those values will override default_cpu_factors on node level
  // MemoryFactors
  default_memory_factors?: MemoryFactors;
  
  // ProviderLimitation_DiskPerformance
  disk_performances?: ProviderLimitation_DiskPerformance[];
}

// Fixed disk performance settings for this node size on a given cloud provider.
// When a deployment of this node size is created, it will be allowed only one DP setting (based on the cloud provider).
// If unspecified, the defaults are loaded from the DiskPerformances specified in the CP.
// If organizations are explicitly allowed to have custom disk settings, they may
// configure other DP settings (excluding the ones specified in ExcludedDiskPerformanceIDs).
// In most situations, where we allow only one fixed setting, `ExcludedDiskPerformanceIDs` holds no meaning.
export interface ProviderLimitation_DiskPerformance {
  // ID of the disk performance that this node size supports on the given cloud provider.
  // string
  disk_performance_id?: string;
  
  // Optional name of the storage class
  // string
  storage_class?: string;
}

// Request arguments for RemoveDeploymentNotificationFromAll
export interface RemoveDeploymentNotificationFromAllRequest {
  // ID of the notification to remove from every deployment.
  // string
  notification_id?: string;
}

// Request arguments for RemoveDeploymentNotificationRequest
export interface RemoveDeploymentNotificationRequest {
  // Identifier of the deployment to remove notification.
  // string
  deployment_id?: string;
  
  // ID of the Notification
  // string
  notification_id?: string;
}

// Replication provides settings to replicate data between ArangoDB deployments.
export interface Replication {
  // Is the replication support for a deployment enabled.
  // Note that this will not start an actual replication, it only makes it possible to configure one.
  // boolean
  enabled?: boolean;
  
  // If replication is enabled, this field holds the endpoint of the sync masters
  // of this deployment.
  // This field has the format of a URL.
  // This is a readonly field.
  // string
  sync_endpoint?: string;
  
  // If replication is enabled, this field holds the endpoint of the migration-forwarder service
  // which allows starting streaming connection.
  // This field has the format of a URL.
  // This is a readonly field.
  // string
  forwarder_endpoint?: string;
}

// ResourceIdentifier specifies an identifier usable to select a resource
export interface ResourceIdentifier {
  // The name of the resource
  // string
  name?: string;
  
  // The namespace of the resource
  // string
  namespace?: string;
}

// Request arguments for RotateDeploymentCredentials.
export interface RotateDeploymentCredentialsRequest {
  // ID of the deployment to rotate credentials for.
  // string
  deployment_id?: string;
}

// RotateDeploymentServerInternalRequest request for rotating out servers for a deployment
export interface RotateDeploymentServerInternalRequest {
  // Standard rotation request
  // arangodb.cloud.data.v1.RotateDeploymentServerRequest
  request?: arangodb_cloud_data_v1_RotateDeploymentServerRequest;
  
  // If set, server will be rotated with force, so even if
  // server state is not deemed applicable for a restart.
  // boolean
  force?: boolean;
}

// ScaleNodePoolRequest is used to set requested instances value on node pool
export interface ScaleNodePoolRequest {
  // id of the datacluster
  // string
  datacluster_id?: string;
  
  // name of the nodepool for cloud provider
  // string
  name?: string;
  
  // number of desired instances
  // number
  requested_instances?: number;
}

// ServerNodeAssignment holds the information about pod on node
export interface ServerNodeAssignment {
  // Identifier of the server
  // This field contains the same ID as the ID in ServerStatus inside the Deployment.
  // string
  id?: string;
  
  // Kubernetes node name
  // string
  node_name?: string;
  
  // Zone of the node
  // string
  node_zone?: string;
  
  // If set to true server to node assignment is controlled by kube-arangodb
  // boolean
  is_topology_aware?: boolean;
  
  // Persistent Volume name for the Server
  // string
  persistent_volume_name?: string;
}

// SetCustomNotebookImageRequest is used to set a custom notebook image for deployments.
export interface SetCustomNotebookImageRequest {
  // ID of the deployment to set the custom notebook image.
  // string
  deployment_id?: string;
  
  // Custom notebook image.
  // string
  custom_notebook_image?: string;
}

// SetDeploymentPublicBackupsDisabledRequest is used to disable/enable public backups.
export interface SetDeploymentPublicBackupsDisabledRequest {
  // Id of the deployment to change value for
  // string
  deployment_id?: string;
  
  // Should we disable public backups.
  // boolean
  disabled?: boolean;
}

// Request for SetDeploymentReadOnlyMode rpc.
export interface SetDeploymentReadOnlyModeRequest {
  // ID of the Deployment for which we are setting the server mode.
  // string
  deployment_id?: string;
  
  // If set, the Deployment is set to read-only mode.
  // boolean
  read_only?: boolean;
}

// SetDeploymentSchedulingPolociesEnabledRequest is used to enable/disable usage of scheduling policies on deployment
export interface SetDeploymentSchedulingPoliciesEnabledRequest {
  // Id of the deployment to change value for
  // string
  deployment_id?: string;
  
  // Should we enable scheduling policies on this deployment
  // boolean
  enabled?: boolean;
}
export interface SetDeploymentSchedulingPoliciesRequest {
  // Identifier of the deployment to update the custom command line arguments for.
  // string
  deployment_id?: string;
  
  // A list of scheduling policies ids to set
  // string
  scheduling_policies_ids?: string[];
}

// Request arguments for SetKubeArangodbAdditionalCommandLineArguments
export interface SetKubeArangodbAdditionalCommandLineArgumentsRequest {
  // Identifier of the deployment to update the custom command line arguments for.
  // string
  deployment_id?: string;
  
  // A list of aditional command line arguments for kube-arangodb.
  // string
  kube_arangodb_additional_command_line_arguments?: string[];
}
export interface SetMemberLogLevelRequest {
  // Identifier of the deployment to update the member log level for.
  // string
  deployment_id?: string;
  
  // The new member log level
  // MemberLogLevel
  member_log_level?: MemberLogLevel[];
}

// Request arguments for UpdateDataClusterAnnotations
export interface UpdateDataClusterAnnotationsRequest {
  // Identifier of the datacluster to update the annotations for.
  // string
  datacluster_id?: string;
  
  // List of annotations, containing free text key-value pairs
  // arangodb.cloud.internal.common.v1.KeyValuePair
  annotations?: arangodb_cloud_internal_common_v1_KeyValuePair[];
}

// Request arguments for UpdateDataClusterCiliumHubble
export interface UpdateDataClusterCiliumHubbleRequest {
  // Identifier of the datacluster to change the Cilium Hubble settings for.
  // string
  datacluster_id?: string;
  
  // If set this datacluster will have Hubble enabled, otherwise it will be disabled.
  // boolean
  enable_hubble?: boolean;
}

// Request arguments for UpdateDataClusterCoreDump
export interface UpdateDataClusterCoreDumpRequest {
  // Identifier of the datacluster to update the core dump enabled for.
  // string
  datacluster_id?: string;
  
  // The new is_core_dump_enabled setting.
  // boolean
  is_core_dump_enabled?: boolean;
}

// Request argument for UpdateDataClusterCredentials.
export interface UpdateDataClusterCredentialsRequest {
  // Identifier of the datacluster to update credentials for.
  // string
  datacluster_id?: string;
  
  // The new credentials
  // DataClusterCredentials
  credentials?: DataClusterCredentials;
}

// UpdateDataClusterDiskSizesRequest is used to update data cluster's (liki/promethues/NATS) disk size
export interface UpdateDataClusterDiskSizesRequest {
  // Identifier of the datacluster
  // string
  datacluster_id?: string;
  
  // If set, the quantity to use for the persistent volume for NATS Streaming.
  // (follows kubernetes resource request format)
  // If not set the disk size is not updated.
  // string
  nats_streaming_disk_size?: string;
  
  // If set, the quantity to use for the persistent volume for NATS JetStream.
  // (follows kubernetes resource request format)
  // If not set the disk size is not updated.
  // string
  nats_jetstream_disk_size?: string;
  
  // If set, the quantity to use for the persistent volume for Loki.
  // (follows kubernetes resource request format)
  // If not set the disk size is not updated.
  // string
  loki_disk_size?: string;
  
  // If set, the quantity to use for the persistent volume for Prometheus.
  // (follows kubernetes resource request format)
  // If not set the disk size is not updated.
  // string
  prometheus_disk_size?: string;
}

// Request arguments for UpdateDataClusterMaintenanceMode
export interface UpdateDataClusterMaintenanceModeRequest {
  // Identifier of the datacluster to set the maintenance mode for.
  // string
  datacluster_id?: string;
  
  // The new mainenance mode.
  // boolean
  in_maintenance_mode?: boolean;
}

// UpdateDataClusterNodeUpdateConcurrencyLevelRequest is used to update the number of nodes that can be updated concurrently
export interface UpdateDataClusterNodeUpdateConcurrencyLevelRequest {
  // Identifier of the datacluster
  // string
  datacluster_id?: string;
  
  // The number of nodes that can be updated concurrently
  // Value <= 1 means that only a single node is updated at a time. Default value is 0
  // number
  node_update_concurrency_level?: number;
}

// Request arguments for UpdateDataClusterOtelEnabled
export interface UpdateDataClusterOtelEnabledRequest {
  // Identifier of the datacluster to update the OTel enabled setting for.
  // string
  datacluster_id?: string;
  
  // The new is_otel_enabled setting.
  // boolean
  is_otel_enabled?: boolean;
}

// Request arguments for UpdateDataClusterPrometheusMemory
export interface UpdateDataClusterPrometheusMemoryRequest {
  // Identifier of the datacluster to set the prometheus memory setting for.
  // string
  datacluster_id?: string;
  
  // The memory size limit for Prometheus (follows kubernetes resource Quantity format)
  // string
  prometheus_memory_size_limit?: string;
}

// Request arguments for UpdateDataClusterRebootNodesAllowed
export interface UpdateDataClusterRebootNodesAllowedRequest {
  // Identifier of the datacluster to update the reboot nodes allowed for.
  // string
  datacluster_id?: string;
  
  // The new reboot nodes allowed setting.
  // boolean
  reboot_nodes_allowed?: boolean;
}

// Request arguments for UpdateDataClusterUpgradeNodepoolsAllowed
export interface UpdateDataClusterUpgradeNodepoolsAllowedRequest {
  // Identifier of the datacluster to upgrade the nodepools allowed for.
  // string
  datacluster_id?: string;
  
  // The new upgrade nodepools allowed setting.
  // boolean
  upgrade_nodepools_allowed?: boolean;
}

// UpdateDataClusterVolumeInfosRequest is used to update data cluster's volume infos  (like type, iops and throughput) and disk performance settings.
export interface UpdateDataClusterVolumeInfosRequest {
  // Identifier of the datacluster
  // string
  datacluster_id?: string;
  
  // The volume info attributes (like type, iops and throughput) for NATS Streaming.
  // If not set the volume info is not updated.
  // VolumeInfo
  nats_streaming_volume_info?: VolumeInfo;
  
  // The volume info attributes (like type, iops and throughput) for NATS JetStream.
  // If not set the volume info is not updated.
  // VolumeInfo
  nats_jetstream_volume_info?: VolumeInfo;
  
  // The volume info attributes (like type, iops and throughput) for Loki.
  // If not set the volume info is not updated.
  // VolumeInfo
  loki_volume_info?: VolumeInfo;
  
  // The volume info attributes (like type, iops and throughput) for Prometheus.
  // If not set the volume info is not updated.
  // VolumeInfo
  prometheus_volume_info?: VolumeInfo;
}

// Request arguments for UpdateDeploymentAddonResources.
export interface UpdateDeploymentAddonResourcesRequest {
  // Identifier of the deployment.
  // string
  deployment_id?: string;
  
  // Absolute addon resource requests (gateway / dedicated LB) for scheduling v3 carve.
  // AddonResources
  addon_resources?: AddonResources;
}

// Request arguments for UpdateDeploymentAgencyResourcesFactor.
export interface UpdateDeploymentAgencyResourcesFactorRequest {
  // Identifier of the deployment.
  // string
  deployment_id?: string;
  
  // A factor that is applied to calculate the memory & CPU resources for an
  // agency.
  // This factor is applied on the default resource size which is calculated
  // for an agency.
  // The minimum value for this field is 1.0.
  // number
  agency_resources_factor?: number;
}

// Request arguments for UpdateDeploymentAllowTraffic
export interface UpdateDeploymentAllowTrafficRequest {
  // Identifier of the deployment to update settings for.
  // string
  deployment_id?: string;
  
  // The new block all incoming traffic mode.
  // boolean
  block_all_incoming_traffic?: boolean;
}

// Request arguments for UpdateDeploymentAnnotations
export interface UpdateDeploymentAnnotationsRequest {
  // Identifier of the deployment to update the annotations for.
  // string
  deployment_id?: string;
  
  // List of annotations, containing free text key-value pairs
  // arangodb.cloud.internal.common.v1.KeyValuePair
  annotations?: arangodb_cloud_internal_common_v1_KeyValuePair[];
}

// Request arguments for UpdateDeploymentArangodbPlatformBundleRequest
export interface UpdateDeploymentArangodbPlatformBundleRequest {
  // Identifier of the deployment to update arangodb platform bundle for.
  // string
  deployment_id?: string;
  
  // Known values: "coredb", "aisuite", "datascience" (see Go constants ArangoDBPlatformBundle*).
  // string
  arangodb_platform_bundle?: string;
}

// Request arguments for UpdateDeploymentArangodbPlatformEnabledRequest
export interface UpdateDeploymentArangodbPlatformEnabledRequest {
  // Identifier of the deployment to update arangodb platform enabled for.
  // string
  deployment_id?: string;
  
  // arangodb platform enabled
  // boolean
  arangodb_platform_enabled?: boolean;
}

// Request arguments for UpdateDeploymentCPUFactors.
export interface UpdateDeploymentCPUFactorsRequest {
  // Identifier of the deployment.
  // string
  deployment_id?: string;
  
  // The CPU factors for the individual components.
  // CPUFactors
  cpu_factors?: CPUFactors;
}

// Request arguments for UpdateDeploymentCPURatio.
export interface UpdateDeploymentCPURatioRequest {
  // Identifier of the deployment.
  // string
  deployment_id?: string;
  
  // The percent ratio between components of the ArangoDB deployment.
  // CPURatio
  cpu_ratio?: CPURatio;
}

// Request arguments for UpdateDeploymentCommunicationMethod.
export interface UpdateDeploymentCommunicationMethodRequest {
  // Identifier of the deployment.
  // string
  deployment_id?: string;
  
  // New communication method to use for the deployment
  // string
  communication_method?: string;
}

// Request arguments for UpdateDeploymentCoreDumpFilter
export interface UpdateDeploymentCoreDumpFilterRequest {
  // Identifier of the deployment to update
  // string
  deployment_id?: string;
  
  // The custom core dump filter to apply to this deployment.
  // This can be empty to revert to the default.
  // CoreDumpFilter
  custom_core_dump_filter?: CoreDumpFilter;
}

// Request arguments for UpdateDeploymentCustomCommandLineArguments
export interface UpdateDeploymentCustomCommandLineArgumentsRequest {
  // Identifier of the deployment to update the custom command line arguments for.
  // string
  deployment_id?: string;
  
  // A list of custom command line arguments for agents.
  // string
  agents_custom_command_line_arguments?: string[];
  
  // A list of custom command line arguments for dbservers.
  // string
  dbservers_custom_command_line_arguments?: string[];
  
  // A list of custom command line arguments for coordinators.
  // string
  coordinators_custom_command_line_arguments?: string[];
  
  // A list of custom command line arguments for gateways.
  // string
  gateways_custom_command_line_arguments?: string[];
}

// UpdateDeploymentCustomStorageClassRequest is used to update deployment's custom storage class
export interface UpdateDeploymentCustomStorageClassRequest {
  // Identifier of the deployment.
  // string
  deployment_id?: string;
  
  // The name of the custom storage class
  // string
  custom_storage_class_name?: string;
}

// UpdateDeploymentDiskSizeRequest is used to update deployment's (dbserver) disk size
export interface UpdateDeploymentDiskSizeRequest {
  // Identifier of the deployment.
  // string
  deployment_id?: string;
  
  // Amount of disk space per db server (in GiB)
  // number
  dbserver_disk_size?: number;
  
  // If set this method will NOT respect the maximum disk-size allowed by the node-size, allowing to set larger disks - as custom setting - for a deployment.
  // boolean
  ignore_maximum_size?: boolean;
}

// Request arguments for UpdateDeploymentEndpointAllowlists
export interface UpdateDeploymentEndpointAllowlistsRequest {
  // Identifier of the deployment to update the endpoint allowlist for.
  // string
  deployment_id?: string;
  
  // Endpoints to allow (in format supported by arangod).
  // string
  allowed_endpoints?: string[];
}

// UpdateDeloymentEnvoyAccessLogRequest is used to enable/disable envoy access for deployment
export interface UpdateDeploymentEnvoyAccessLogRequest {
  // Id of the delpoyment that access log should be enabled/disabled for
  // string
  deployment_id?: string;
  
  // If true, envoy will log requests in access log
  // boolean
  enable?: boolean;
}

// Request arguments for UpdateDeploymentFirstUpToDateAfterImplicitMaintenanceMode
export interface UpdateDeploymentFirstUpToDateAfterImplicitMaintenanceModeRequest {
  // Identifier of the deployment to update the first up-to-date after implicit maintenance mode for.
  // string
  deployment_id?: string;
}

// Request arguments for UpdateDeploymentGatewayResourcesFactor.
export interface UpdateDeploymentGatewayResourcesFactorRequest {
  // Identifier of the deployment.
  // string
  deployment_id?: string;
  
  // A factor that is applied to calculate the memory & CPU resources for a
  // gateway.
  // This factor is applied on the default resource size which is calculated
  // for a gateway.
  // The minimum value for this field is 1.0.
  // number
  gateway_resources_factor?: number;
}

// Request arguments for UpdateDeploymentHibernationMode
export interface UpdateDeploymentHibernationModeRequest {
  // Identifier of the deployment to update the hibernation mode for.
  // string
  deployment_id?: string;
  
  // The new hibernation mode.
  // boolean
  in_hibernation_mode?: boolean;
}

// Request arguments for UpdateDeploymentHibernationModeStatus
export interface UpdateDeploymentHibernationModeStatusRequest {
  // Identifier of the deployment to update the hibernation mode status for.
  // string
  deployment_id?: string;
  
  // The new hibernation mode status.
  // boolean
  is_hibernated?: boolean;
}
export interface UpdateDeploymentKubeArangodbRequest {
  // Identifier of the deployment to update the kube-arangodb settings for.
  // string
  deployment_id?: string;
  
  // Kube-arangodb settings
  // KubeArangodb
  kube_arangodb?: KubeArangodb;
}

// Request arguments for UpdateDeploymentLastActiveAt
export interface UpdateDeploymentLastActiveAtRequest {
  // Identifier of the deployment to set last_active_at.
  // string
  deployment_id?: string;
  
  // Timestamp of when this deployment was last active (i.e: had incoming user traffic).
  // googleTypes.Timestamp
  last_active_at?: googleTypes.Timestamp;
}

// Request arguments for UpdateDeploymentLastReportedProvisionHash
export interface UpdateDeploymentLastReportedProvisionHashRequest {
  // Identifier of the deployment to update the last reported provision hash for.
  // string
  deployment_id?: string;
  
  // Contains the last reported provision hash of the data-cluster for this deloyment.
  // string
  last_reported_provision_hash?: string;
}

// Request arguments for UpdateDeploymentLastReportedRevision
export interface UpdateDeploymentLastReportedRevisionRequest {
  // Identifier of the deployment to update the last reported revision for.
  // string
  deployment_id?: string;
  
  // Revision that was last reported from data-cluster
  // number
  last_reported_revision?: number;
}

// Request arguments for UpdateDeploymentLoadBalancer
export interface UpdateDeploymentLoadBalancerRequest {
  // Identifier of the deployment to update the loadbalancer settings for.
  // string
  deployment_id?: string;
  
  // If set the deployment will use a shared loadbalancer.
  // Otherwise a dedicated loadbalancer will be used.
  // This setting is a don't care if use_internal_loadbalancer is set.
  // boolean
  use_shared_loadbalancer?: boolean;
  
  // If set the deployment will use an internal loadbalancer.
  // This setting has preference above the use_shared_loadbalancer setting.
  // boolean
  use_internal_loadbalancer?: boolean;
}

// Request arguments for UpdateDeploymentMaintenanceMode
export interface UpdateDeploymentMaintenanceModeRequest {
  // Identifier of the deployment to update the maintenance mode for.
  // string
  deployment_id?: string;
  
  // The new mainenance mode.
  // boolean
  in_maintenance_mode?: boolean;
}

// Request arguments for UpdateDeploymentMemoryFactors.
export interface UpdateDeploymentMemoryFactorsRequest {
  // Identifier of the deployment.
  // string
  deployment_id?: string;
  
  // The memory factors for the individual components.
  // MemoryFactors
  memory_factors?: MemoryFactors;
}

// Request arguments for UpdateDeploymentMemoryRatio.
export interface UpdateDeploymentMemoryRatioRequest {
  // Identifier of the deployment.
  // string
  deployment_id?: string;
  
  // The percent ratio between components of the ArangoDB deployment.
  // MemoryRatio
  memory_ratio?: MemoryRatio;
}

// UpdateDeploymentMemoryReservesRequest is used to update deployment's components memory reserves
export interface UpdateDeploymentMemoryReservesRequest {
  // Identifier of the deployment.
  // string
  deployment_id?: string;
  
  // Agents memory reserve.
  // If not set it won't update agents memory reserve.
  // MemoryReserve
  agents_memory_reserve?: MemoryReserve;
  
  // Coordinators memory reserve.
  // If not set it won't update coordinators memory reserve.
  // MemoryReserve
  coordinators_memory_reserve?: MemoryReserve;
  
  // Dbservers memory reserve.
  // If not set it won't update dbservers/single memory reserve.
  // MemoryReserve
  dbservers_memory_reserve?: MemoryReserve;
  
  // If set the memory reserves for agents will be removed from the deployment, and the default from the version will be used.
  // If set the agents_memory_reserve field will be ignored.
  // boolean
  agents_memory_reserve_to_default?: boolean;
  
  // If set the memory reserves for coordinators will be removed from the deployment, and the default from the version will be used.
  // If set the coordinators_memory_reserve field will be ignored.
  // boolean
  coordinators_memory_reserve_to_default?: boolean;
  
  // If set the memory reserves for dbservers/single will be removed from the deployment, and the default from the version will be used.
  // If set the dbservers_memory_reserve field will be ignored.
  // boolean
  dbservers_memory_reserve_to_default?: boolean;
}

// Request arguments for UpdateDeploymentNotificationRequest
export interface UpdateDeploymentNotificationRequest {
  // Identifier of the deployment to update notification.
  // string
  deployment_id?: string;
  
  // ID of the Notification
  // string
  notification_id?: string;
  
  // String representation of the Notification
  // string
  notification_text?: string;
  
  // Notification Severity
  // arangodb.cloud.data.v1.NotificationSeverity
  severity?: arangodb_cloud_data_v1_NotificationSeverity;
  
  // The timestamp of when the notification expires.
  // googleTypes.Timestamp
  expires_at?: googleTypes.Timestamp;
}

// Request arguments for UpdateDeploymentReplicationRequest.
export interface UpdateDeploymentReplicationRequest {
  // Identifier of the deployment.
  // string
  deployment_id?: string;
  
  // The replication settings for the the ArangoDB deployment.
  // Replication
  replication?: Replication;
}

// Request arguments for UpdateDeploymentRestoreBackup
export interface UpdateDeploymentRestoreBackupRequest {
  // Identifier of the deployment to restore the backup for.
  // string
  deployment_id?: string;
  
  // The identifier of the backup (inside the backup service).
  // string
  backup_id?: string;
}

// UpdateDeploymentSchedulingVersionRequest sets the scheduling version for a deployment.
export interface UpdateDeploymentSchedulingVersionRequest {
  // Id of the deployment to update
  // string
  deployment_id?: string;
  
  // Target scheduling version. If unset (0), the latest scheduling version is used.
  // number
  version?: number;
}

// Request arguments for UpdateDeploymentServerNodeAssignments
export interface UpdateDeploymentServerNodeAssignmentsRequest {
  // Identifier of the deployment.
  // string
  deployment_id?: string;
  
  // Servers assignments to Nodes.
  // ServerNodeAssignment
  server_node_assignments?: ServerNodeAssignment[];
}

// Request arguments for UpdateDeploymentSupportPlan
export interface UpdateDeploymentSupportPlanRequest {
  // Identifier of the deployment to update
  // string
  deployment_id?: string;
  
  // Identifier of the new support plan
  // string
  support_plan_id?: string;
}

// UpdateDeploymentSuppressAlertsRequest is used to update deployment's alerts silenced status
export interface UpdateDeploymentSuppressAlertsRequest {
  // Identifier of the deployment.
  // string
  deployment_id?: string;
  
  // If set, the deployment alerts are silenced
  // boolean
  suppress_alerts?: boolean;
}

// UpdateDeploymentTargetCpuArchitectureRequest sets the desired CPU architecture for the managed deployment.
export interface UpdateDeploymentTargetCpuArchitectureRequest {
  // Identifier of the deployment.
  // string
  deployment_id?: string;
  
  // Target architecture: "amd64" or "arm64".
  // string
  target_cpu_architecture?: string;
}

// UpdateDeploymentToUseJetStreamForAuditLogsRequest is used to enable/disable usage of JetStream for audit logs on deployment
export interface UpdateDeploymentToUseJetStreamForAuditLogsRequest {
  // Id of the deployment to change value for
  // string
  deployment_id?: string;
  
  // Should we enable JetStream for audit logs on this deployment
  // boolean
  use_jetstream_for_auditlogs?: boolean;
}

// Request argumens for UpdateDeploymentTopologyAwareness
export interface UpdateDeploymentTopologyAwarenessRequest {
  // Identifier of the deployment.
  // string
  deployment_id?: string;
  
  // If set, enable topology awareness
  // boolean
  topology_aware?: boolean;
  
  // Override number of zones from data cluster
  // If set to <= 0, will use value from data cluster
  // number
  number_of_zones_override?: number;
}

// Request arguments for UpdateDeploymentUpToDate
export interface UpdateDeploymentUpToDateRequest {
  // Identifier of the deployment to update the up-to-date setting for.
  // string
  deployment_id?: string;
  
  // The new up-to-date state.
  // boolean
  is_up_to_date?: boolean;
}

// UpdateDeploymentUseShardRebalancerRequest is used to update deployment's use shard rebalancer setting
export interface UpdateDeploymentUseShardRebalancerRequest {
  // Identifier of the deployment.
  // string
  deployment_id?: string;
  
  // If set, the deployment will use shard rebalancer
  // boolean
  use_shard_rebalancer?: boolean;
}

// Request arguments for UpdateDeploymentVSTEnabledRequest
export interface UpdateDeploymentVSTEnabledRequest {
  // Identifier of the deployment to update vst enabled for.
  // string
  deployment_id?: string;
  
  // vst enabled
  // boolean
  vst_is_enabled?: boolean;
}

// UpdateDeploymentVolumeInfosRequest is used to update deployment's volume infos  (like type, iops and throughput) and disk performance settings.
export interface UpdateDeploymentVolumeInfosRequest {
  // Identifier of the deployment.
  // string
  deployment_id?: string;
  
  // Agent volume info.
  // If not set it won't update agent volume info.
  // VolumeInfo
  agents_volume_info?: VolumeInfo;
  
  // Dbservers volume info.
  // If not set it won't update dbservers/single volume info.
  // VolumeInfo
  dbservers_volume_info?: VolumeInfo;
  
  // Identifier of the disk performance.
  // This is an optional field, not setting the field will preserve the existing disk performance identifier.
  // string
  disk_performance_id?: string;
  
  // If set, the disk performance will be locked and the (public) UpdateDeployment method cannot change it.
  // If not set the locked state will be removed (if it was set previously)
  // boolean
  disk_performance_locked?: boolean;
  
  // If set, the (regular) VolumeInfo which belongs to the specified disk performance will be applied to the deployment.
  // The agents_volume_info and dbservers_volume_info fields will be ignored in this case.
  // If not set, the new provided or existing volume info (if any) will be preserved.
  // boolean
  use_regular_volume_info?: boolean;
}

// UpdateKubernetesResourcesPatchesRequest is used to update deployment's kubernetes resources patches
export interface UpdateKubernetesResourcesPatchesRequest {
  // Identifier of the deployment to update the annotations for.
  // string
  deployment_id?: string;
  
  // Kubernetes resource for which the patches should be applied. (eg: ArangoDeployment, CloudDeployment)
  // string
  resource_type?: string;
  
  // List of patches, containing free text key-value pairs
  // arangodb.cloud.internal.common.v1.JSONPatch
  patches?: arangodb_cloud_internal_common_v1_JSONPatch[];
}
export interface UpdateUsageItemReconciliationRequest {
  // Identifier of the deployment to update the usage item reconciliation for.
  // string
  deployment_id?: string;
  
  // The usage item reconciliation to update
  // map<string, googleTypes.Timestamp>
  usage_item_reconciliation?: { [key: string]: googleTypes.Timestamp };
  
  // Overwrite existing usage_item_reconciliation timestamps, instead of merging
  // boolean
  overwrite?: boolean;
}
export interface ValidateDeploymentRequest {
  // Identifier of the organization
  // string
  organization_id?: string;
  
  // Deployment resource spec to be validated
  // arangodb.cloud.data.v1.Deployment
  deployment?: arangodb_cloud_data_v1_Deployment;
}

// VersionInfo holds detailed information of an ArangoDB version.
export interface VersionInfo {
  // ArangoDB image to use for this image
  // string
  image?: string;
}

// VolumeInfo specifies the volume info attributes (like type, iops and throughput) for the deployment
// All fields inside this message are read-only.
export interface VolumeInfo {
  // The desired volume type
  // The value should be compatible by the provider (e.g. 'gp2' or 'gp3' for AWS)
  // string
  type?: string;
  
  // The desired volume IOPS value
  // The value should be compatible for the specified type (e.g. '10000' for gp3)
  // number
  iops?: number;
  
  // The desired volume Throughput value in MiB/s
  // The value should be compatible for the specified type (e.g. '500' for gp3)
  // number
  throughput?: number;
  
  // True if these values are provider's defaults
  // boolean
  is_provider_default?: boolean;
}

// DataClusterDedicationMode says at what granularity a data cluster is
// dedicated to an organization. Which deployments share a cluster decides how
// the dedicated-data-cluster addon is charged: a cluster of its own is billed
// through its own sales order, a cluster serving a single deployment is billed
// through that deployment's.
export enum DataClusterDedicationMode {
  // Not dedicated: an ordinary shared platform cluster. Also the value of a
  // dedicated cluster created before this field existed — a non-empty
  // private_to_organizations with this mode means "not recorded yet", not
  // "not dedicated".
  DATA_CLUSTER_DEDICATION_MODE_NONE = 0,
  
  // Dedicated to a single deployment: the organization had
  // has_private_data_cluster_per_deployment enabled when the cluster was created.
  DATA_CLUSTER_DEDICATION_MODE_PER_DEPLOYMENT = 1,
  
  // Dedicated to one organization and shared by several of its deployments.
  DATA_CLUSTER_DEDICATION_MODE_PER_MULTIPLE_DEPLOYMENTS = 2,
}

// PackPlanStatus describes whether a pack unit can be executed.
export enum PackPlanStatus {
  PACK_PLAN_STATUS_UNSPECIFIED = 0,
  
  // Pack unit needs work; ExecutePack may be used.
  PACK_PLAN_STATUS_READY = 1,
  
  // Dbserver and coordinator are on the target node. Gateway and load balancer
  // do not decide this status. ExecutePack rejects it.
  PACK_PLAN_STATUS_ALREADY_PACKED = 2,
  
  // Pack unit cannot be executed (e.g. missing 1:1 pairing).
  PACK_PLAN_STATUS_INELIGIBLE = 3,
}

// InternalDataService is the API used to configure internal aspects of data resources
export interface IInternalDataService {
}

// InternalDataService is the API used to configure internal aspects of data resources
export class InternalDataService implements IInternalDataService {
}
